import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import AppHeader from "../Comp/AppHeader";

const Privacy = () => {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Find Out Our Privacy policy here in Appspace Solutions.</title>
        <meta
          name="description"
          content="Privacy Policy followed by Appspace Solutions on its online Apps and Website. If you have any questions please feel free to contact us using the given information."
        />
      </Helmet>

      <AppHeader name="privacy" indexSlide={0} />

      <main>
        <div className="pt-20 w-5/6 md:w-3/4 px-1  break-words md:px-0 m-auto text-gray-700 text-xl">
          <h1 className="mt-20 font-bold text-5xl text-gray-800">
            Privacy Policy
          </h1>
          <p className="mt-4 font-medium">Last Update: July 7, 2026</p>
          <p className="mt-4 font-medium">
            Photo editor & Video editor - Merger IO, a developer account operated under <strong>AppSpace Solutions</strong> ("we," "our," or "us"), respects and protects users' privacy. In this policy, <strong>pay attention to the bold letters.</strong> They hold significant importance to your rights and possible interests. Please read and understand the policy carefully before using our products and services.
          </p>
          <p className="mt-4 font-medium">
            This page informs you of our policies regarding collecting, using, and disclosing personal data when you use our Products or Services and the choices you have associated with that data.
          </p>
          <p className="mt-4 font-medium">
            We use your data to provide and improve the Service. By using the Service, you agree to the collection and use of information under this policy. Unless otherwise defined in this Privacy Policy, the terms used in this Privacy Policy have the same meanings as in our Terms and Conditions.
          </p>

          <h2 className="mt-10 text-gray-800 text-3xl font-bold">Overview of Privacy Policy</h2>
          <ol className="list-decimal pl-6 space-y-2">
            <li><a href="#OverviewofPrivacyPolicy">Overview of Privacy Policy</a></li>
            <li><a href="#Definitions">Definitions</a></li>
            <li><a href="#CollectionandUse">Collection and Use of User’s Personal Information</a></li>
            <li><a href="#ReasontoCollect">Reason to Collect User&apos;s Information</a></li>
            <li><a href="#ShareTransferandPublicdisclosure">Share, Transfer and Public Disclosure of User’s Personal Information</a></li>
            <li><a href="#StorageandProtection">Storage and Protection of User’s Personal Information</a></li>
            <li><a href="#UseofCookies">Use of Cookies</a></li>
            <li><a href="#DataProtectionOfficerDPO">Data Protection Officer (DPO)</a></li>
            <li><a href="#OurUser’sRights">Our User’s Rights</a></li>
            <li><a href="#UsersofCalifornia">Users of California</a></li>
            <li><a href="#EUUsers">EU Users</a></li>
            <li><a href="#UsersofBrazil">Users of Brazil</a></li>
            <li><a href="#UsersofVirginia">Users of Virginia</a></li>
            <li><a href="#DMCACopyrightPolicy">DMCA Copyright Policy</a></li>
            <li><a href="#Infringementpolicy">Infringement policy</a>
              <ol className="list-lower-alpha pl-6">
                <li><a href="#HowtoReportInfringement">How to Report Infringement</a></li>
              </ol>
            </li>
            <li><a href="#In-appAdvertisements">In-app Advertisements</a></li>
            <li><a href="#In-appPurchases">In-app Purchases</a></li>
            <li><a href="#LiabilityLimitation">Liability Limitation</a></li>
            <li><a href="#DisclaimerofWarranty">Disclaimer of Warranty</a></li>
            <li><a href="#CopyrightandTrademarks">Copyright and Trademarks</a></li>
            <li><a href="#PushNotifications">Push Notifications</a></li>
            <li><a href="#Retentionofdata">Retention of data</a></li>
            <li><a href="#AccountLeaderboardDeletion">Account &amp; Leaderboard Data Deletion</a></li>
            <li><a href="#DataRecoveryPolicy">Data Recovery Policy</a></li>
            <li><a href="#Securityofdata">Security of data</a></li>
            <li><a href="#OurPolicyOnDONOTTRACKSignalsUnderTheCaliforniaOnlineProtectionActCALOPPA">Our Policy On “DO NOT TRACK” Signals Under The California Online Protection Act (CALOPPA)</a></li>
            <li><a href="#ServiceProviders">Service Providers</a>
              <ol className="list-lower-alpha ml-8">
                <li><a href="#Disclaimer">Disclaimer</a>
                  <ol className="list-lower-roman ml-8">
                    <li><a href="#Analytics">Analytics</a></li>
                    <li><a href="#Advertising">Advertising</a></li>
                    <li><a href="#BehavioralRemarketing">Behavioral Remarketing</a></li>
                  </ol>
                </li>
              </ol>
            </li>
            <li><a href="#Payments">Payments</a></li>
            <li><a href="#LinkstootherSites">Links to other sites</a></li>
            <li><a href="#ChildrensPrivacy">Children’s Privacy</a></li>
            <li><a href="#PrivacyPolicyChanges" id="Definitions">Privacy Policy Changes</a></li>
            <li><a href="#ContactUs">Contact Us</a></li>
          </ol>

          <h2 className="mt-10 text-gray-800 text-3xl font-bold">
            Definitions
          </h2>
          <p>We have added this part so that users can easily understand the basics of the privacy policy.
          </p>
          <ul className="ml-10 mt-2">
            <li className="list-disc font-semibold pb-4">
              <h3>Service</h3>
              <p className="font-normal">
                Service means games, mobile applications, other products (“Games”), and websites operated by Photo editor & Video editor - Merger IO, a developer account operated under AppSpace Solutions (“we,” “our,” or “us”).
              </p>
            </li>
            <li className="list-disc font-semibold pb-4">
              <h3>Personal Data </h3> <br />
              <p className="font-normal">
                Personal Data means data about a living individual who can be identified from that data (or from those and other information either in our possession or likely to come into our possession)
              </p>
            </li>
            <li className="list-disc font-semibold pb-4">
              <h3> Usage Data</h3> <br />
              <p className="font-normal">
                Usage Data is data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).
              </p>
            </li>
            <li className="list-disc font-semibold pb-4">
              <h3>Cookies
              </h3>  <br />
              <p className="font-normal">
                Cookies are small files stored on your device (computer or mobile device).
              </p>
            </li>
            <li className="list-disc font-semibold pb-4">
              <h3>Data Controller</h3>  <br />
              <p className="font-normal">
                Data Controller means the natural or legal person who (either alone or jointly or in common with other persons) determines the purposes for which and how any personal information is, or is to be, processed. For this Privacy Policy, we are a Data Controller of your Personal Data.
              </p>
            </li>
            <li className="list-disc font-semibold pb-4">
              <h3>Data Processors (or Service Providers)</h3>   <br />
              <p className="font-normal">
                Data Processor (or Service Provider) means any natural or legal person who processes the data on behalf of the Data Controller. We may use the services of various Service Providers to process your data more effectively.
              </p>
            </li>
            <li className="list-disc font-semibold pb-4">
              <h3> Data Subject (or User)</h3> <br />
              <p className="font-normal">
                Data Subject is any living individual who is using our Service and is the subject of Personal Data.

              </p>
            </li>
            <li className="list-disc font-semibold pb-4">
              <h3>Data Protection Officer(DPO) </h3> <br />
              <p className="font-normal" id="CollectionandUse">
                A DPO is a designated person who is in charge of managing an organization's or company's data protection policy and making sure that data protection rules and laws, like the General Data Protection Regulation (GDPR) in the European Union, are followed. The DPO plays a critical role in safeguarding individuals' rights to privacy by making sure that personal data is handled safely and in compliance with the law.
              </p>
            </li>
            <li className="list-disc font-semibold pb-4">
              <h3>Player ID / Game Account </h3> <br />
              <p className="font-normal" id="CollectionandUse">
                A Player ID or Game Account is a unique identifier that you create via Google, Facebook or default login through Device ID. It is used to save your progress, sync data across devices, and identify you on Leaderboards.
              </p>
            </li>
            <li className="list-disc font-semibold pb-4">
              <h3>Leaderboard Data </h3> <br />
              <p className="font-normal" id="CollectionandUse">
                Leaderboard Data means the in-game nickname/username, score, rank, and achievement data that is displayed publicly or to other players within the Service as part of competitive or social gameplay features.
              </p>
            </li>
          </ul>
          <h2 className="text-3xl mt-10 font-bold text-gray-900">
            Collection and Use of User’s Personal Information
          </h2>
          <p className="mt-2 ">
            Photo editor & Video editor - Merger IO, a developer account operated under AppSpace Solutions (“we,” “our,” or “us”).
          </p>
          <p className="mt-2 ">
            We may collect certain non-personal and device-related information such as usage data, device information, advertising identifiers, and analytics data to provide, maintain, and improve our services. This data may be processed and shared with trusted third-party service providers such as Google Firebase for analytics, performance monitoring, and app optimization purposes.
          </p>
          <p className="mt-2 ">The different types of permissions we ask from users to offer the best of our products and services are- </p>
          <p className="mt-2 font-semibold">1. All File Access-</p>
          <p className="mt-2">
            We need this permission to provide our users with a comprehensive and seamless experience. This permission enables us to provide advanced features, making it simple for you to organize and enjoy your media effortlessly.
          </p>
          <p className="mt-2">
            With <a href="https://support.google.com/googleplay/android-developer/answer/10467955?hl=en" className="text-blue-600 underline">ALL FILES ACCESS</a>  permission, the app can perform all functions of file management (e.g., deleting, renaming, moving media files), browse, read, manage, download, and display any format of video files, audio files, images, or any media files on the device without limiting the user to specific app folders. This permission lets the app gather all media files on your device and display them in one place.
          </p>
          <p className="my-2">
            Users can open and play any video or audio file stored on their device without needing to manually move the file to a specific folder or provide additional access permissions. Users get multiple options to manage files within the app, such as:
          </p>
          <ul className="list-disc ml-8">
            <li>Deleting unwanted media files.</li>
            <li>Renaming files.</li>
            <li>Moving or copying files between directories.</li>
          </ul>
          <h2 className="mt-4 font-bold">ENCRYPTION AND DECRYPTION OF FILES</h2>
          <p className="mt-2">
            <strong>Encryption:</strong> The app allows users to encrypt their media files for added security. For example, if a user wants to secure sensitive video files, the app can encrypt these files with an algorithm (e.g., AES-256 encryption). The ALL FILES ACCESS permission is necessary to locate the files, read their contents, and apply encryption.
          </p>
          <p className="mt-2">
            <strong>Decryption:</strong> When users want to access encrypted media, the app uses the ALL FILES ACCESS permission to locate the encrypted files, read their content, and decrypt them for playback within the app.
          </p>
          <p className="mt-2">
            All encryption and decryption processes are done locally on the device, ensuring that no personal data is transmitted to external servers or third parties.
          </p>
          <h2 className="mt-4 font-bold">Data Collection for iOS Users</h2>
          <ul className="list-disc ml-8 mt-2">
            <li className="mt-2">
              Under Apple’s App Store policies, we disclose the following data types that may be collected and linked to your identity:
            </li>

            <li className="mt-2">
              <strong>Data Collected:</strong>
            </li>

            <li className="mt-2">
              <strong>a. Personal Information (Provided by You)</strong><br />
              • Email Address<br />
              • Password (securely stored using encryption)<br />
              • User ID (associated with your account or sign-in method)<br />
              <em>Use of this Data-</em> For login, account management, and premium service access.
            </li>

            <li className="mt-2">
              <strong>b. Third-Party Sign-In Information</strong><br />
              • Google Account Data (Name, email, profile picture, and unique Google user ID via Google Sign-In)<br />
              • Facebook Account Data (Name, email, profile picture, friends list and unique Facebook user ID via Facebook Login)<br />
              • Apple ID Data (Email and basic profile info via Sign in with Apple)<br />
              <em>Use of this Data-</em> Solely to authenticate your identity, create your Game Account, and enable saved progress and leaderboard features. No additional data (e.g., contacts, posts) is accessed or stored.
            </li>

            <li className="mt-2">
              <strong>c. Device & Network Data (Automatically Collected)</strong><br />
              • IP Address<br />
              • Country (Derived from IP Address)<br />
              • Connection Status (Connected/Disconnected, duration, timestamps)<br />
              • Connection History (Time-stamped records of connection attempts; stored anonymously unless linked with your account)<br />
              • Server Information (Server selected, server region, parent server if applicable)<br />
              • Device Information (such as device type, OS version — non-identifiable)<br />
              <em>Use of this Data-</em> To optimize your experience and ensure service stability.
            </li>

            <li className="mt-2">
              <strong>d. Subscription & Premium Status</strong><br />
              • Status and validity of your premium plan<br />
              • Purchase receipts from Apple’s in-app purchase system (we do not store payment information)
            </li>

            <li className="mt-2">
              <strong>Data NOT Collected:</strong><br />
              We do not collect sensitive personal data such as contacts, photos, or personal files. However, we may collect non-personal data such as device information, usage data, and analytics data as described in this policy.
            </li>

            <li className="mt-2">
              <strong>Sign-In Data (Google &amp; Facebook)</strong><br />
              Sign-in to this game is required and is limited to the following two providers.<br /><br />
              <strong>Google Sign-In</strong><br />
              • Data Collected: Name, email address, profile picture, unique Google user ID<br />
              • Use of this Data: Account creation, authentication, saved progress, leaderboard identity<br />
              • Governed by: Google's Privacy Policy<br /><br />
              <strong>Facebook Login</strong><br />
              • Data Collected: Name, email address, public profile picture, friends list, unique Facebook user ID<br />
              • Use of this Data: Account creation, authentication, saved progress, leaderboard identity<br />
              • Governed by: Meta's Privacy Policy and Facebook Platform Data Use Policy<br /><br />
              <em>Data NOT Collected via either provider:</em> account password, posts, messages, or any data beyond the basic profile fields listed above.
            </li>

          </ul>
          <div className="mt-4">
            <span className="font-bold">2. Local Media Permission-</span> This permission allows the app to access photos, videos, and audio files stored on your device. We use this permission so you can browse and select media files to cast to your TV or other compatible devices. Without this access, the app cannot display your media library or stream selected files.
            <p>On devices running Android 13 and above, the app requests READ_MEDIA_IMAGES and READ_MEDIA_VIDEO permissions to access photos and videos you choose to edit or include in collages. On Android 14 and above, the app may use the READ_MEDIA_VISUAL_USER_SELECTED permission, which allows you to grant access only to specific images and videos you select, rather than your entire media library. These permissions are used solely within the app and no media files are uploaded to external servers.</p>
          </div>
          <div className="mt-4">
            <span className="font-bold">3. Network-</span> This permission is required when you need to download any social media videos (using our Video Downloader feature), Network streaming, to find and connect to nearby casting devices on your Wi-Fi network, or watch online trending videos when your device is connected to WLAN or Mobile Data. We do not collect or store any information through this but only perform the functions mentioned before.

          </div>
          <div className="mt-4">
            <span className="font-bold">4. Location Information-</span> For the VPN Services in Android, we collect your location information based on a variety of sources, such as your device's GPS or by calculating an approximate latitude and longitude based on your IP address.
          </div>
          <div className="mt-4">
            <span className="font-bold">5. Usage and Tracking Data-</span> This Usage Data may include information such as your computer’s Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data. It may also include information such as the type of mobile device you use, your mobile device's unique ID, the IP address of your mobile device, your mobile operating system, the type of mobile Internet browser you use, unique device identifiers, usage patterns, and other diagnostic data. We collect non-personal tracking information to help us improve the App and provide better services.
          </div>
          <div className="mt-4">
            <span className="font-bold">6. Microphone-</span> Microphone access is necessary for using the audio recording feature effectively. This permission is dedicated to recording audio only. Should you delete the audio files from your local storage, we will not and does not store any of that audio material.
          </div>
          <div className="mt-4">
            <span className="font-bold">7. Consumer Support and Follow-up Services-</span> When users send their feedback or error reports via email, we obtain your username, email address, and email content. This helps in communicating with you about any problems you face while using our product or service.
          </div>
          <div className="mt-4">
            <span className="font-bold">8. API-</span> The YouTube API has been incorporated into our software to provide you with smooth access to the platform's services. It's important to mention that if you use any of our services, a third party may be notified about which parts of our Platform you have operated. Under GDPR legislation, the use of these services is a legitimate interest as defined by Art. 6(1)(f) DSGVO. For more, check- <br />
            <a href="https://www.youtube.com/t/terms" className='text-blue-700 underline'>https://www.youtube.com/t/terms</a> <br />
            <a href="https://policies.google.com/privacy" className='text-blue-700 underline'>https://policies.google.com/privacy</a> <br />
          </div>
          <div className="mt-4">
            <span className="font-bold">9. Sensitive Personal Data-</span> We do not ask for or collect any Sensitive Personal Data or information such as passwords related to other services, financial information such as bank account or credit card, debit card, or other payment instrument details, physical, physiological, and mental health conditions, sexual orientation, medical records, and history, or biometric information.
          </div>
          <p className="mt-2">
            <strong>Note:</strong> Our app uses on-device face detection and image segmentation via Google ML Kit solely to enhance image editing features. This processing happens locally on your device and does not constitute biometric identification. No facial data is stored, transmitted, or shared.
          </p>

          <div className="mt-4">
            <span className="font-bold">10. iOS App Permissions-</span> For iOS users, we need the following permissions-
            <ul className="list-disc ml-6 mt-2">
              <li><strong>Network Extension / VPN Configuration-</strong> We need this permission to route traffic securely via VPN.</li>
              <li><strong>Background App Refresh-</strong> This permission is required to maintain a VPN connection.</li>
              <li><strong>Push Notifications-</strong> We ask for this permission to keep users updated.</li>
            </ul>
          </div>
          <div className="mt-4">
            <span className="font-bold">11. Notification Permission-</span> For devices with Android 13 and above, with your permission, we may send notifications to inform you of important events, messages, news, or updates related to the casting process. You can turn these notifications on or off at any time in your device settings. We do not use notifications for unsolicited advertising.
          </div>

          <div className="mt-4">
            <span className="font-bold">12. AI Features – Image Processing-</span> Our app uses Google&apos;s ML Kit and MediaPipe to power certain AI-based image editing features. Specifically, the app uses the following on-device capabilities:
            <ul className="list-disc ml-6 mt-2">
              <li><strong>Face Detection</strong> — Detects faces within images to enable features such as auto-framing or smart cropping.</li>
              <li><strong>Selfie &amp; Subject Segmentation</strong> — Separates the subject (person or object) from the background in images to enable background removal or replacement features.</li>
            </ul>
            <p className="mt-2 font-semibold">Important disclosures regarding these features:</p>
            <ul className="list-disc ml-6 mt-2">
              <li>All processing is performed entirely on your device using Google ML Kit and MediaPipe. No facial data, biometric identifiers, or segmented images are sent to our servers or any third party.</li>
              <li>We do not store, share, or use any facial data for identification, profiling, or advertising purposes.</li>
              <li>These features only activate when you explicitly use them within the app.</li>
              <li>No facial recognition or biometric identification is performed — the app only detects the presence and position of faces to improve image composition.</li>
            </ul>
            <p className="mt-2">
              If you choose to use our AI-based image-to-image generation or editing features, the app may temporarily process your selected images locally or via secure servers strictly for the purpose of generating results. These images are not stored or shared after processing unless you explicitly save them on your device.
            </p>
          </div>

          <div className="mt-4">
            <span className="font-bold">13. Crash Logs &amp; Diagnostics-</span> To improve stability and identify bugs, our app may collect anonymized crash logs and diagnostic reports. These logs do not include personal content (such as photos, videos, or private files) and are used solely for troubleshooting and performance optimization.
          </div>

          <div className="mt-4">
            <span className="font-bold">14. Storage Permission-</span> The app requests access to your device&apos;s storage in order to read, modify, or delete media files as per your actions inside the app.
            <ul className="list-disc ml-6 mt-2">
              <li>The app requests <strong>MANAGE_EXTERNAL_STORAGE</strong> only to let users play, organize, clean, and secure their media files.</li>
              <li>All operations are performed <strong>locally on the device</strong> and no media files are uploaded or shared externally.</li>
            </ul>
          </div>

          <div className="mt-4">
            <span className="font-bold">15. Biometric Authentication-</span> Our app may use biometric authentication features available on your device (such as fingerprint) to protect access to your private vault.
            <p className="mt-2">We do not collect, store, or share your biometric data. This authentication is handled entirely by your device&apos;s operating system. We only receive a confirmation of successful authentication to grant access.</p>
          </div>

          <div className="mt-4">
            <span className="font-bold">16. Wake Lock Permission-</span> Our app uses this to keep your device awake temporarily while performing essential tasks such as processing images, playing videos, or completing ongoing operations. This permission does not collect or share any personal data and is used solely to ensure smooth app functionality.

          </div>

          <div className="mt-4">
            <span className="font-bold">17. Account Sign-In &amp; Leaderboard Services - </span>
            To offer saved progress, cross-device play, and competitive leaderboards, our game requires you to sign in using one of the following third-party providers. We do not offer email/password or guest account creation. Sign-in is required to play, and is limited to:
            <ul className="list-disc ml-6 mt-2">
              <li><strong>Google Sign-In:</strong> We receive your name, email address, and profile picture as provided by your Google account, and a unique Google user identifier, solely to authenticate you and create your Game Account.</li>
              <li><strong>Facebook Login:</strong> We receive your name, email address, friends list, and public profile picture as provided by Facebook, and a unique Facebook user identifier, solely to authenticate you and create your Game Account.</li>
            </ul>
            <p className="mt-2">
              We do not receive your Google or Facebook account password. We do not access your Google contacts, Gmail, or Facebook posts/timeline through this sign-in. Access is limited strictly to basic profile fields (name, email, profile picture) needed for authentication.
            </p>
            <p className="mt-2">
              <strong>Leaderboard Display:</strong> If you participate in a Leaderboard, your in-game nickname (which by default is derived from your Google/Facebook display name unless you set a custom nickname) and your score/rank may be visible to other players of the Service. We do not display your email address or any other personal contact information on a Leaderboard. You may set a custom, non-identifying nickname in Settings if you do not want your Google/Facebook name shown publicly.
            </p>
            <p className="mt-2">
              <strong>Data Not Collected:</strong> We do not access your Google contacts, and we do not post to your Facebook account on your behalf.
            </p>
          </div>

          <div className="mt-4">
            <span className="font-bold">18. Device Identifiers - </span>
            In addition to the Usage Data described above, we collect certain device identifiers to support account security, fraud prevention, analytics, and advertising:
            <ul className="list-disc ml-6 mt-2">
              <li><strong>App Set ID (Android) / Identifier for Vendor – IDFV (iOS):</strong> an alphanumeric identifier that is shared across apps published by us on your device, but not shared with other publishers' apps. This helps us recognize returning users across our own apps for analytics and fraud-prevention purposes. It resets if you uninstall all of our apps from your device.</li>
              <li><strong>Advertising Identifiers — GAID (Android) / IDFA (iOS):</strong> a resettable, user-controlled identifier used for ad targeting, attribution, and frequency capping, as already described in the "Advertising" section of this policy. You can reset or limit this at any time via your device's ad settings.</li>
              <li><strong>Persistent vs. Non-Persistent Identifiers:</strong> some identifiers above remain constant until reset by you (persistent), while others may rotate periodically depending on your device's operating system settings (non-persistent).</li>
              <li>We do not collect an Apple Game Center identifier, as this Service does not use Game Center for sign-in.</li>
              <li><strong>Use of this Data —</strong> Account authentication support, fraud/abuse prevention, analytics, crash diagnostics, and (for advertising identifiers only) ad personalization and measurement, consistent with the "Advertising" and "Service Providers" sections of this policy.</li>
            </ul>
          </div>

          <h2 className="text-3xl mt-10 font-bold text-gray-900" id="DataTypesCollected">
            Data Types Collected
          </h2>

          <p className="mt-2">
            We may collect the following types of information:</p>

          <ul className="list-disc ml-8 mt-2">
            <li className="mt-2">Device Information (device model, OS version)</li>
            <li className="mt-2">Advertising ID</li>
            <li className="mt-2">IP Address</li>
            <li className="mt-2">App usage data (interactions, session duration)</li>
            <li className="mt-2">Crash logs and diagnostics</li>
            <li className="mt-2">App activity (such as feature usage, interactions, and session duration)</li>
            <li className="mt-2">Other app performance data (such as crash logs, diagnostics, and performance metrics)</li>
            <li className="mt-2">Player ID / Game Account identifier (from Google or Facebook)</li>
            <li className="mt-2">Name, email address, and profile picture (from Google or Facebook sign-in)</li>
            <li className="mt-2">In-game nickname or username</li>
            <li className="mt-2">Leaderboard scores, rank, and achievement data</li>
            <li className="mt-2">App Set ID (Android) / IDFV (iOS) — vendor-scoped device identifier</li>
            <li className="mt-2">Advertising ID (GAID/IDFA) — resettable ad identifier</li>
          </ul>

          <h2 className="text-3xl mt-10 font-bold text-gray-900" id="ReasontoCollect">
            Reasons to Collect Users&apos; Information
          </h2>
          <p className="mt-2">
            We use the collected data for various purposes:</p>

          <ul className="list-disc ml-8 mt-2">
            <li className="mt-2">To provide and maintain our Service</li>
            <li className="mt-2">To enable casting or screen mirroring functionality</li>
            <li className="mt-2">To notify you about changes to our Service</li>
            <li className="mt-2">To allow you to participate in interactive features of our Service when you choose to do so</li>
            <li className="mt-2">To provide customer support</li>
            <li className="mt-2">To gather analysis or valuable information so that we can improve our Service</li>
            <li className="mt-2">To monitor the usage of our Service</li>
            <li className="mt-2">To detect, prevent, and address technical issues</li>
            <li className="mt-2">To follow legal guidelines</li>
            <li className="mt-2">To enable AI-powered features such as image-to-image generation or editing.</li>
            <li className="mt-2">To identify and resolve bugs by analyzing crash logs and diagnostic reports.</li>
            <li className="mt-2">To create and authenticate your Game Account</li>
            <li className="mt-2">To save and sync your game progress across devices</li>
            <li className="mt-2">To enable leaderboard, ranking, and achievement features</li>
            <li className="mt-2">To moderate publicly displayed nicknames and prevent abuse on Leaderboards</li>
          </ul>
          <h2 className="text-3xl mt-10 text-black font-semibold">
            How We Use Data Collected from iOS Users
          </h2>
          <p className="mt-2">
            We use the collected data for various purposes:
          </p>
          <ul className="list-disc ml-8 mt-2">
            <li className="mt-2">Provide and maintain the VPN service.</li>
            <li>Authenticate and manage user accounts.</li>
            <li>Personalize user experience.</li>
            <li>Improve service performance and stability.</li>
            <li>Provide support and respond to user queries.</li>
            <li>Prevent fraudulent activity and ensure secure access.</li>
            <li>To enhance security, including enabling device-level authentication, such as fingerprint, for protected features.</li>

          </ul>
          <br />
          <h2 className="text-3xl mt-10 text-black font-semibold">
            Use of data
          </h2>
          <p className="mt-2">
            We use the collected data for various purposes:
          </p>
          <ul className="list-disc ml-8 mt-2">
            <li className="mt-2">To provide and maintain our Service</li>
            <li>To notify you about changes to our Service</li>
            <li>
              To allow you to participate in interactive features of our Service
              when you choose to do so
            </li>
            <li>To provide customer support</li>
            <li>
              To gather analysis or valuable information so that we can improve
              our Service
            </li>
            <li>To monitor the usage of our Service</li>
            <li id="ShareTransferandPublicdisclosure">
              To detect, prevent and address technical issues
            </li>
          </ul>
          <br />

          <h2 className="mt-6 text-black font-semibold text-3xl">
            Share, Transfer and Public Disclosure of User’s Personal Information
          </h2>
          <h3 className="mt-6 text-black font-semibold">SHARE</h3>
          <p className="mt-2 ">
            Your privacy is our priority. User Data is never uploaded or shared with third parties. Your personal details are kept confidential, and we only share what&apos;s essential under the conditions mentioned in this policy.
          </p>
          <p className="mt-2 font-semibold">Obtained your permission:</p>
          <ul className="list-disc ml-8 mt-2">
            <li className="mt-2">When needed to comply with state agencies, authority, or administrative or legal instructions.</li>
            <li className="mt-2">
              To meet the objectives stated in &apos;Collection and Use of User&apos;s Personal Information&apos;.
            </li>
            <li className="mt-2">Share with ad services and tech support partners.
            </li>
          </ul>
          <p className="mt-2 ">A list of available third-party SDKs for integration is mentioned below under the <strong>“Service Providers”</strong>.
          </p>
          <h3 className="mt-6 text-black font-semibold">TRANSFER</h3>

          <p className="mt-2">
            We will not disclose your personal information to any company, organization, or individual, except as required by law, administrative enforcement, or regulatory authorities.
          </p>

          <h3 className="mt-6 text-black font-semibold">PUBLIC DISCLOSURE</h3>

          <p className="mt-2" id="StorageandProtection">
            As required by laws, regulations, or legal authorities, we may need to share your personal information with enforcement or regulatory bodies. Any disclosure will be limited to the specific information requested and will follow the prescribed legal procedures.
          </p>
          <h2 className="mt-6 text-black font-semibold text-3xl">
            Storage and Protection of User’s Personal Information
          </h2>
          <p className="mt-2">
            Our app requires access to your device’s media storage to provide seamless functionality, such as browsing, playing, downloading and managing your media files. This access is granted through the <a href="https://developer.android.com/training/data-storage/shared/media" className="text-blue-700 underline">Media Storage Permission </a> as per Google’s guidelines. By allowing this permission, our app can retrieve and display media files stored on your device, such as videos, music, and any format of media files to enhance your user experience. Rest assured, we only access the necessary media files for the app’s core functions, and we do not collect, store, share, or sell any personal information from your media library. Users retain full control over their files, and data is handled responsibly in compliance with Google's policies to ensure privacy and security.
          </p>
          <p className="mt-2">
            For AI-powered features, any processing of user images occurs either locally on your device or via encrypted channels. Processed images are not retained on our servers beyond the session. Crash logs and diagnostics are anonymized before storage, ensuring no personal data can be linked back to an individual.
          </p>
          <h3 className="mt-4 text-xl font-bold text-gray-900">Local HTTP Server (NanoHTTPD)</h3>
          <p className="mt-2">
            Our app uses NanoHTTPD, a lightweight open-source library, to create a local HTTP server environment on your device. This server operates entirely on your device (localhost) and is used solely for the offline gaming feature.
          </p>
          <ul className="list-disc ml-6 mt-2">
            <li>The local server does not transmit any data to external servers or third parties.</li>
            <li>It does not accept connections from other devices on your network.</li>
            <li>It is only active when offline gaming is in use and does not run persistently in the background.</li>
            <li>No personal data, media files, or user information is served through or exposed by this local server.</li>
          </ul>
          <h2 className="mt-4 font-bold">For iOS Users</h2>

          <ul className="list-disc ml-6">
            <li className="mt-2">
              Any data we collect complies with App Store Review Guidelines, Apple’s Developer Program License Agreement, Apple’s Data Collection & Privacy Policies, and Relevant privacy laws like GDPR and CCPA.
            </li>
            <li className="mt-2">
              Passwords are stored using secure encryption methods.
            </li>
            <li className="mt-2">
              All sensitive data (email, IP address, logs) is encrypted in transit and at rest.
            </li>
            <li className="mt-2">
              Data is stored only as long as necessary for the purposes outlined in this policy.
            </li>
            <li className="mt-2">
              You can check different Apple guidelines from the links below:
              <ul className="list-disc ml-6 mt-2">
                <li>
                  <a
                    href="https://developer.apple.com/app-store/review/guidelines/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline"
                  >
                    App Store Review Guidelines
                  </a>
                </li>
                <li className="mt-1">
                  <a
                    href="https://developer.apple.com/support/terms/apple-developer-program-license-agreement/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline"
                  >
                    Apple’s Developer Program License Agreement
                  </a>
                </li>
                <li className="mt-1">
                  <a
                    href="https://www.apple.com/in/legal/privacy/en-ww/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline"
                  >
                    Apple’s Data Collection & Privacy Policies
                  </a>
                </li>
              </ul>
            </li>
          </ul>


          <p className="mt-4" id="UseofCookies">
            We use Firebase by Google for analytics. You can check its privacy policy for more.
            Firebase-<a href="https://firebase.google.com/support/privacy" className="text-blue-700 underline">https://firebase.google.com/support/privacy</a>
          </p>
          <h2 className="text-3xl mt-8 text-black font-semibold">
            Use of Cookies
          </h2>
          <p className="mt-2">
            We value your privacy and treat data collected through cookies and similar technologies as non-personal information. A "cookie" is a small piece of data stored on your device by websites to help enhance your browsing experience. These cookies do not contain personal details such as your name, email address, or any other identifiable information. Instead, they are used to recognize your device and remember preferences or actions taken during your visit. You have the option to disable cookies at any time through your browser settings.
          </p>
          <p className="mt-2">
            Examples of Cookies we use:<br />
          </p>
          <ul className="list-disc ml-8 mt-2">
            <li className="mt-2">
              Session Cookies<br />
              We use Session Cookies to operate our Service.
            </li>
            <li className="mt-2">
              Preference Cookies<br />
              We use Preference Cookies to remember your preferences and various settings.
            </li>
            <li className="mt-2" id="DataProtectionOfficerDPO">
              Security Cookies<br />
              We use Security Cookies for security purposes.
            </li>
            <li className="mt-2" id="OurUser’sRights">Advertising Cookies<br />
              Advertising Cookies are used to serve you with advertisements that may be relevant to you and your interests.
            </li>
          </ul>
          <h2 className="text-3xl mt-8 text-black font-semibold">
            Data Protection Officer (DPO)
          </h2>
          <p className="mt-2">
            We have appointed a Data Protection Officer (DPO) to oversee our data protection strategy and ensure that our app complies with privacy regulations. The DPO is responsible for:
          </p>
          <ul className="list-disc ml-8 mt-2">
            <li className="mt-2">
              Monitoring compliance with data protection laws.
            </li>
            <li className="mt-2">Acting as a point of contact for data protection-related inquiries.
            </li>
            <li className="mt-2">Assisting users in exercising their data protection rights.
            </li>
          </ul>
          <p className="mt-2">If you have any questions about your privacy or would like to exercise any of your rights under applicable laws, please contact our DPO.</p>
          <p className="mt-2"><strong>Contact Information for the DPO:</strong></p>
          <ul>
            <li><strong>Email: </strong> feedback@appspacesolutions.in</li>
            <li><strong>Contact No.: </strong>+91 8433400233</li>
          </ul>
          <h2 className="text-3xl mt-8 text-black font-semibold">Our User’s Rights</h2>
          <p className="mb-4">Depending on the laws in your jurisdiction, you may have several rights regarding your personal information. These rights could include:</p>
          <ul className="list-disc list-inside mb-4">
            <li><strong>Access to Information:</strong> You can request information about the data we have collected about you.</li>
            <li><strong>Manage Permissions:</strong> You may revoke any permissions you’ve previously granted, such as access to your camera or photo library.</li>
            <li><strong>Data Deletion:</strong> Request the deletion of your personal information.</li>
            <li><strong>Opt-Out:</strong> You can choose to opt out of receiving personalized advertisements.</li>
            <li>You can opt out of third-party login and use email/password instead.</li>
            <li>You may request access, correction, or deletion of your personal data.</li>
            <li>You may disable account tracking or data collection for analytics in Settings.</li>
          </ul>
          <p className="mb-4">To exercise these rights, contact us at feedback@appspacesolutions.in. California residents should refer to the &quot;Users of California&quot; section, users from Brazil should refer to &quot;Users of Brazil&quot; and EU users should consult the &quot;EU Users&quot; section for further details.</p>
          <h2 className="text-3xl mt-8 text-black font-semibold" id="YourPrivacyRightsAndChoices">Your Privacy Rights and Choices</h2>
          <h3 className="text-2xl mt-4 text-black font-semibold">Opt-Out of Data Sharing and Targeted Advertising</h3>
          <p className="mb-4 mt-2">We respect our users' privacy and provide them with control over how their data is used.</p>
          <p className="mb-4">We do not sell personal information of children under any circumstances.</p>
          <p className="mb-4">For general users, we do not use personal data for targeted or behavioral advertising unless explicitly stated.</p>
          <p className="mb-4">You have the right to opt out of the sharing of your data for advertising or analytics purposes.</p>
          <p className="mb-2">You can exercise this right by:</p>
          <ul className="list-disc list-inside mb-4">
            <li>Disabling Ad Personalization in your device settings.</li>
            <li>Resetting or limiting your Advertising ID (AAID/IDFA).</li>
            <li>Contacting us at feedback@appspacesolutions.in with the subject: "Opt-Out Request".</li>
          </ul>
          <p className="mb-4">Once we receive your request, we will process it within a reasonable timeframe in accordance with applicable laws such as GDPR, CCPA, and other privacy regulations.</p>

          <h2 className="text-3xl mt-8 text-black font-semibold" id="UsersofCalifornia">Right to Lodge a Complaint</h2>
          <p className="mb-4">You have the right to lodge a complaint with a competent supervisory authority if you believe that your data protection rights have been violated.</p>

          <p className="mb-4">For users in the European Economic Area (EEA), you may contact your local data protection authority. A list of supervisory authorities is available through your country’s official data protection body.</p>

          <p className="mb-4">For users in other regions, you may contact your relevant regulatory authority or data protection authority in your jurisdiction.</p>

          <p className="mb-4">We encourage you to contact us first at  <a href="mailto:feedback@appspacesolutions.in" className="text-blue-600"> feedback@appspacesolutions.in </a>, and we will do our best to address your concerns promptly and transparently.</p>

          <h2 className="text-3xl mt-8 text-black font-semibold" id="UsersofCalifornia">Users of California</h2>
          <p className="mb-4">If you are a California resident, you have the following rights according to CCPA:</p>
          <ul className="list-disc list-inside mb-4">
            <li><strong>Right to Know:</strong> Users have the right to know about how their personal information is being used or shared.</li>
          </ul>
          <ul className="list-disc list-inside mb-4">
            <li><strong>Right to Access:</strong> Request information about the personal data we have collected about you.
            </li>
          </ul>
          <ul className="list-disc list-inside mb-4">
            <li><strong>Right to Delete:</strong> Request deletion of your personal data.</li>

          </ul>
          <ul className="list-disc list-inside mb-4">
            <li><strong>Right to Opt-Out:</strong> Opt-out of the sale of your personal data (Note: We do not sell personal data).</li>
          </ul>
          <p className="mb-4">To exercise these rights, please contact us at <a href="mailto:feedback@appspacesolutions.in" className="text-blue-600">feedback@appspacesolutions.in</a>.</p>

          <h2 className="text-3xl mt-8 text-black font-semibold" id="EUUsers">EU Users</h2>
          <p className="mb-4">For EU users, under the GDPR, you have the right to:</p>
          <ul className="list-disc list-inside mb-4">
            <li><strong>Right to Access:</strong> Request access to your personal data and obtain a copy.</li>
            <li><strong>Right to Rectification:</strong> Request correction of inaccurate personal data.</li>
            <li><strong>Right to Erasure:</strong> Request deletion of your personal data.</li>
            <li><strong>Right to Restrict Processing:</strong> Request restriction of processing your personal data.</li>
            <li><strong>Right to Data Portability:</strong> Request transfer of your data to another organization.</li>
            <li><strong>Right to Object:</strong> Object to the processing of your personal data.</li>
          </ul>
          <p className="mb-4">To exercise these rights, please contact us at <a href="mailto:feedback@appspacesolutions.in" className="text-blue-600">feedback@appspacesolutions.in</a>.</p>

          <h2 className="text-3xl mt-8 text-black font-semibold" id="UsersofBrazil">Users of Brazil
          </h2>
          <p className="mb-4">If you are in Brazil, you have the following rights under the LGPD:</p>
          <ul className="list-disc list-inside mb-4">
            <li><strong>Right to Confirmation:</strong> Confirm the existence of processing of your personal data.
            </li>
            <li><strong>Right to Access:</strong>  Access your personal data.
            </li>
            <li><strong>Right to Correction:</strong>  Correct incomplete, inaccurate, or outdated data.</li>
            <li><strong>Right to Deletion:</strong>Request deletion of unnecessary or excessive data.
            </li>
            <li><strong>Right to Data Portability:</strong>  Request transfer of your data to another service provider.
            </li>
            <li><strong>Right to Opposition:</strong> Oppose the processing of your personal data in certain situations.
            </li>
          </ul>
          <p className="mb-4">To exercise these rights, please contact us at <a href="mailto:feedback@appspacesolutions.in" className="text-blue-600">feedback@appspacesolutions.in</a>.</p>

          <h2 className="text-3xl mt-8 text-black font-semibold" id="UsersofVirginia">Users of Virginia
          </h2>
          <p className="mb-4">For residents of Virginia, they have certain rights under the Virginia Consumer Data Protection Act (VCDPA), including the right to access, delete, and opt out of specific types of data processing.</p>
          <h3 className="text-2xl mt-4 text-black font-semibold">How We Use Data</h3>
          <p className="mb-2">We may access and process certain data, like:</p>
          <ul className="list-disc list-inside mb-4">
            <li>Files and media stored on your device (only to provide core file management features).</li>
            <li>Device identifiers (such as Advertising ID).</li>
            <li>App usage data for analytics and performance improvement.</li>
          </ul>
          <p className="mb-4">We do not sell your personal data. However, we may use trusted third-party services (such as analytics and advertising providers) that may process limited data for personalized advertising or app performance analysis.</p>
          <h3 className="text-2xl mt-4 text-black font-semibold">Your Right to Opt-Out</h3>
          <p className="mb-2">You have the right to opt out of:</p>
          <ul className="list-disc list-inside mb-4">
            <li>Targeted advertising.</li>
            <li>The processing of personal data for analytics (where applicable).</li>
            <li>Profiling in furtherance of decisions that produce legal or similarly significant effects.</li>
          </ul>
          <p className="mb-2">You can exercise your opt-out rights through the following methods:</p>
          <p className="mb-1"><strong>1. In-App Controls</strong></p>
          <p className="mb-3">If available, you can manage your privacy preferences directly within the app settings, including disabling personalized ads.</p>
          <p className="mb-1"><strong>2. Device-Level Controls</strong></p>
          <p className="mb-1">You can limit data used for advertising by:</p>
          <ul className="list-disc list-inside mb-3">
            <li>Disabling ad personalization in your device settings.</li>
            <li>Resetting or deleting your Advertising ID (Android/iOS).</li>
          </ul>
          <p className="mb-1"><strong>3. Contact Us</strong></p>
          <p className="mb-3">You may submit a request to opt out by contacting us at: feedback@appspacesolutions.in.</p>
          <p className="mb-4">We will review and respond to your request within the timeframe required by applicable law. We do not discriminate against you for exercising your privacy rights.</p>

          <h2 className="text-3xl mt-8 text-black font-semibold" id="DMCACopyrightPolicy">
            DMCA Copyright Policy
          </h2>
          <p className="mt-4">
            All Content available on the Platform is licensed from third-party services such as YouTube. All copyrights are owned by their respective owners and are used with permission. The Platform only provides outbound links to these Third-Party Services and has no direct control over their content. In compliance with the Digital Millennium Copyright Act, the Company has adopted the following general stance toward copyright infringement.
          </p>
          <p className="mt-4" id="Infringementpolicy">YouTube Content: third-party content available through the use of Google’s API (such as text, images, videos, audio, or software) hosted by YouTube.
          </p>

          <h2 className="text-3xl mt-8 text-black font-semibold">
            Infringement policy
          </h2>
          <p className="mt-4" id="HowtoReportInfringement">
            We respect the intellectual property rights of others and expect our users to do the same. If you believe that your copyrighted work or intellectual property has been used in a way that constitutes infringement within our app, please notify us immediately.
          </p>

          <h3 className="text-xl mt-8 text-black font-semibold">
            How to Report Infringement
          </h3>
          <p className="mt-4">
            If you believe your rights have been violated, please provide us with the following information:
          </p>
          <ul className="list-disc list-inside mb-4">
            <li>A description of the copyrighted or intellectual property that you claim has been infringed.
            </li>
            <li>A description of where the material in question is located within the app (such as a link or screenshot).
            </li>
            <li>Your contact information, including your name, email address, and phone number.</li>
            <li>A statement that you have a good faith belief that the use of the material is not authorized by the copyright owner, its agent, or the law.
            </li>
            <li id="In-appAdvertisements">A statement that the information provided in the notification is accurate and that you are the copyright or intellectual property owner or authorized to act on behalf of the owner.
            </li>
          </ul>
          <p className="mb-4">To submit your infringement claim, please contact us at: <a href="mailto:feedback@appspacesolutions.in" className="text-blue-600">feedback@appspacesolutions.in</a>.</p>
          <h2 className="text-3xl mt-8 text-black font-semibold">
            In-app Advertisements
          </h2>
          <p className="mt-4">
            We reserve the right to place adverts on the platforms in order to
            maintain the free functionalities. These advertisements may be
            interspersed with other features, and some of those features may
            only be activated if you view the ads. If you choose to stop seeing
            certain adverts, you might lose access to those features or
            encounter other app restrictions.
          </p>
          <p className="mt-2">
            Your use of the App may be terminated if you use any method to get
            around any In-app advertisements.
          </p>
          <p className="mt-2">
            Before displaying any personalized advertisements, we use Google&apos;s User Messaging Platform (UMP) to request your consent in accordance with applicable privacy laws. You may update your ad consent preferences at any time through the app&apos;s settings.
          </p>
          <h2 className="text-3xl mt-8 text-black font-semibold" id="In-appPurchases">
            In-App Purchases
          </h2>
          <p className="mt-4">
            We offer you choices with in-app purchases to improve your user
            experience and let you explore and take advantage of more features
            across the platform.
          </p>
          <p className="mt-2">
            If you wish to make any purchase, you do so through either Google
            Play service or Apple iTunes service and also agreeing to their
            respective Terms and Conditions.
          </p>
          <a
            href="https://play.google.com/intl/en-us/about/play-terms/index.html"
            className="text-blue-600"
          >
            https://play.google.com/intl/en-us/about/play-terms/index.html
          </a>{" "}
          <br />
          <a
            href="https://www.apple.com/legal/internet-services/itunes/"
            className="text-blue-600"
          >
            https://www.apple.com/legal/internet-services/itunes/
          </a>{" "}
          <br />
          <p className="mt-2" id="LiabilityLimitation">
            Also, it is to be noted that we&apos;re not a party to any In-app purchases.
          </p>

          <p>When you make an in-app purchase, your purchase history and subscription status are recorded locally on your device via Google Play Billing. We do not store payment card details. Purchase history is used solely to validate and restore your premium access.</p>

          <h2 className="text-3xl mt-8 text-black font-semibold">
            Liability Limitation
          </h2>
          <p className="mt-2">
            Photo editor & Video editor - Merger IO shall in no event be liable for any loss or damage (incidental, or consequential) of your device or files, including photos, videos, documents, and music, caused by-
            <br /> <br />
          </p>
          <ul className="ml-8 list-disc">
            <li>
              Access or inability to access the services offered in our apps.
            </li>
            <li>Any third party&apos;s conduct.</li>
            <li id="DisclaimerofWarranty">
              Unauthorized or inappropriate use of our services in mobile applications other than what they were intended for.
            </li>
          </ul>
          <h2 className="text-3xl mt-8 text-black font-semibold">
            Disclaimer of Warranty
          </h2>
          <p className="mt-4" id="CopyrightandTrademarks">
            Services provided by Photo editor & Video editor - Merger IO, a developer account operated under <strong> AppSpace Solutions </strong> (“we,” “our,” or “us”), through mobile applications are provided “as is" and “as available,” with no warranties (expressed or implied). It also includes but is not limited to warranties of quality, marketability, fitness of services for particular purposes, or non-infringement. You use our services at your own risk and only as permitted by law.
          </p>

          <h2 className="text-3xl mt-8 text-black font-semibold">
            Copyright and Trademarks
          </h2>
          <p className="mt-4">
            Our apps give users the ability to create their own content. We will never claim ownership of your original work. You alone remain the sole person responsible for every piece of content you create, and therefore, you warrant it.
            <br /> <br />

            We own and retain all rights to its content, applications, and services. Whereas our service and content are protected by copyright, trademark, patent, trade secret, and other laws.
            <br /> <br id="PushNotifications" />
            We also reserves the right to use your feedback (without revealing any personal information about the person who provided it) as we see fit. Under no circumstances can the sender of any particular feedback claim ownership of it or ask for payment in return.
          </p>
          <h2 className="text-3xl mt-8 text-black font-semibold">
            Push Notifications
          </h2>
          <p className="mt-4">
            We provide you the choice to receive push notifications to inform you of built-in features of the Application or any additional use of the Platform or you can say enabling In-app notifications is an alternative. If you turn off notifications, you might not get information right away and you can miss out on the latest updates and information.
          </p>
          <h2 className="text-3xl mt-8 text-black font-semibold">
            Termination
          </h2>
          <p className="mt-2" id="Retentionofdata">
            Your access to any particular feature or the entire platform may be terminated if any violation is discovered in any way. The platform may be terminated with or without prior warning, and if for any reason you wish to do so, you may do so by deleting the application from your device.
          </p>
          <h2 className="text-3xl mt-8 text-black font-semibold">
            Retention of data
          </h2>
          <p className="mt-2">
            We will retain your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.
          </p>
          <p className="mt-2">
            We will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of our Service, or we are legally obligated to retain this data for longer periods.
          </p>

          <h2 className="text-3xl mt-8 text-black font-semibold" id="AccountLeaderboardDeletion">
            Account &amp; Leaderboard Data Deletion
          </h2>
          <p className="mt-2">
            If you created a Game Account, you may request deletion of your account and associated Leaderboard Data (nickname, scores, rank, achievements) at any time by:
          </p>
          <ul className="list-disc ml-8 mt-2">
            <li><strong>In-App:</strong> Settings &rarr; Account &rarr; Delete Account, or</li>
            <li><strong>Web Request:</strong> emailing <a href="mailto:feedback@appspacesolutions.in" className="text-blue-600 underline">feedback@appspacesolutions.in</a> with the subject "Delete Game Account," or</li>
            <li><strong>Platform-Level:</strong> revoking this app's access from your Google Account (myaccount.google.com &rarr; Security &rarr; Third-party apps) or Facebook (Settings &rarr; Apps and Websites), which stops further sign-in (note: this does not delete data already stored by us — use option 1 or 2 for full deletion).</li>
          </ul>
          <p className="mt-2">
            We will process account deletion requests immediately and will remove your nickname from public Leaderboards as part of that process. Some data may be retained for a limited period where required for fraud prevention, legal compliance, or dispute resolution, consistent with the "Retention of data" section above.
          </p>

          <h2 className="text-3xl mt-8 text-black font-semibold" id="DataRecoveryPolicy">
            Data Recovery Policy{" "}
          </h2>
          <p className="mt-2">
            Our apps do not support Recoverable action after uninstallation of the app.<strong>If users are using the Hider functionality then it is crucial to remember that you may lose all the trash or hidden data if you clear all your data or factory reset your device.</strong>
          </p>
          <p className="mt-2">
            <strong>
              To prevent your data, you may transfer the trash or hidden files from our app to your device because once you uninstall our app, you won't be able to recover those files. </strong>Our developers will not be liable for any of the private files or data.
          </p>
          <p className="mt-2">
            We prioritize your control over personalized data. You can easily manage and delete your local database, preferences, and logs directly from the app’s settings, without the need to visit any external service or URL. This includes clearing stored information in the local database, resetting your saved preferences, and deleting any logs generated during app usage, such as activity or error logs. All data management actions can be performed entirely within the app, giving you full control over your data without reliance on external platforms. We encourage users to regularly review and manage their data based on personal preferences.
          </p>
          <h2 className="text-3xl mt-8 text-black font-semibold" id="Securityofdata">
            Security of data
          </h2>
          <p className="mt-2">
            The security of your data is important to us but remember that no method of transmission over the Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.
          </p>
          <p className="mt-2">
            We use industry-standard security measures, including device-based protections such as biometric authentication (fingerprint), to safeguard user data stored within the app. We do not collect any biometric data. It is processed locally on your device.
          </p>
          <h2 className="text-3xl mt-8 text-black font-semibold" id="OurPolicyOnDONOTTRACKSignalsUnderTheCaliforniaOnlineProtectionActCALOPPA">
            OUR POLICY ON “DO NOT TRACK” SIGNALS UNDER THE CALIFORNIA ONLINE PROTECTION ACT (CALOPPA)
          </h2>
          <p className="mt-2">We do not support Do Not Track (“DNT”). Do Not Track is a preference you can set in your web browser to inform websites that you do not want to be tracked.</p>
          <p className="mt-2">You can enable or disable Do Not Track by visiting the Preferences or Settings page of your web browser.</p>
          <h2 className="text-black text-3xl mt-4 font-semibold" id="ServiceProviders">
            Service Providers
          </h2>
          <p className="mt-2" id="Disclaimer">
            We may employ third-party companies and individuals (“Service Providers”) to facilitate our Service, provide the Service on our behalf, perform Service-related services, or assist us in analyzing how our Service is used. These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.
          </p>
          <br />
          <p className="text-black text-3xl mt-4 mb-3 font-semibold">
            Disclaimer:
          </p>
          <p className="mt-2" id="Analytics">
            Our apps are not associated with any social media platform. Any unauthorized acts and/or violations of intellectual property rights are solely the user&apos;s responsibility. Before downloading and using the content, we suggest that you seek the permission of the owner.
          </p>
          <h3 className="text-black text-3xl mt-7 mb-3 font-semibold">
            Analytics
          </h3>
          <p>
            We may use third-party Service Providers to monitor and analyze the
            use of our Service. Analytics is limited to non-personal data.
          </p>

          <ul>
            <li className=" mt-4" >
              <h4><strong>Facebook Analytics</strong></h4>
              <p className="ml-2 mt-2">
                Facebook Analytics is provided by Facebook Inc.
              </p>
              <p className="ml-2">
                We use Facebook Analytics for in-game data analytics to improve
                our games.
              </p>
              <p className="ml-2 mt-2">
                For more information on the privacy practices of Facebook, please
                visit Facebook’s Data Policy:{" "}
                <a
                  href="https://www.facebook.com/privacy/explanation"
                  className="text-blue-400"
                >
                  https://www.facebook.com/privacy/explanation
                </a>{" "}
              </p>
            </li>
            <li className="mt-4">
              <h4><strong>Firebase Services (by Google LLC)</strong></h4>
              <p className="ml-2 mt-2">Our app uses multiple Firebase services provided by Google LLC. Each service is described below:</p>

              <h5 className="ml-2 mt-4 font-semibold">Firebase Analytics</h5>
              <p className="ml-2 mt-2">We use Firebase Analytics to understand how users interact with our app. This helps us improve features, fix issues, and make better product decisions.</p>
              <p className="ml-2 mt-2 font-semibold">Data collected includes:</p>
              <ul className="list-disc ml-8 mt-1">
                <li>App events (e.g., app open, screen views, button taps, feature usage)</li>
                <li>Device information (model, OS version, language, country)</li>
                <li>App version and installation source</li>
                <li>Session duration and frequency of use</li>
                <li>Advertising ID (AAID on Android / IDFA on iOS)</li>
                <li>Crash and ANR (App Not Responding) events</li>
              </ul>
              <p className="ml-2 mt-2 font-semibold">Important disclosures:</p>
              <ul className="list-disc ml-8 mt-1">
                <li>Firebase Analytics data is pseudonymized, which means it is associated with a device identifier, not your name or personal identity</li>
                <li>We do not use Firebase Analytics to access your photos, videos, or any personal files</li>
                <li>Analytics data may be linked with other Firebase services, such as Remote Config and Crashlytics, for a unified view of app performance</li>
                <li>You can opt out of Firebase Analytics data collection at any time by disabling ad personalization in your device settings or by resetting your Advertising ID. On Android, go to Settings → Google → Ads → Reset Advertising ID or Opt Out of Ads Personalization.</li>
              </ul>
              <p className="ml-2 mt-2">For more information, visit: <a href="https://firebase.google.com/support/privacy" className="text-blue-400">https://firebase.google.com/support/privacy</a></p>

              <h5 className="ml-2 mt-4 font-semibold">Firebase Crashlytics</h5>
              <p className="ml-2 mt-2">We use Firebase Crashlytics to automatically detect, log, and report app crashes and stability issues. This allows our team to identify and fix bugs quickly to improve your experience.</p>
              <p className="ml-2 mt-2 font-semibold">Data collected includes:</p>
              <ul className="list-disc ml-8 mt-1">
                <li>Crash stack traces (technical logs showing where the app failed)</li>
                <li>Device state at the time of the crash (OS version, device model, available memory)</li>
                <li>App version and build number</li>
                <li>A randomly generated Crashlytics Installation UUID to track crash frequency per device</li>
                <li>Whether the app was in the foreground or background</li>
              </ul>
              <p className="ml-2 mt-2 font-semibold">Important disclosures:</p>
              <ul className="list-disc ml-8 mt-1">
                <li>Crashlytics does not collect your name, email address, photos, videos, or any personal content</li>
                <li>Crash logs are anonymized and contain only technical diagnostic information</li>
                <li>Logs are used solely for debugging and stability improvement and never for advertising or profiling</li>
              </ul>
              <p className="ml-2 mt-2">For more information, visit: <a href="https://firebase.google.com/support/privacy" className="text-blue-400">https://firebase.google.com/support/privacy</a></p>

              <h5 className="ml-2 mt-4 font-semibold">Firebase Remote Config</h5>
              <p className="ml-2 mt-2">We use Firebase Remote Config to update certain app settings, features, and content remotely without requiring you to download a new version of the app. This allows us to roll out features gradually, run A/B tests, or make quick adjustments to the app experience.</p>
              <p className="ml-2 mt-2 font-semibold">Data collected includes:</p>
              <ul className="list-disc ml-8 mt-1">
                <li>Firebase Installation ID (to identify the app instance for targeted configuration delivery)</li>
                <li>App version and platform information</li>
                <li>User property segments (e.g., app version group, country) are used to determine which configuration to deliver</li>
              </ul>
              <p className="ml-2 mt-2 font-semibold">Important disclosures:</p>
              <ul className="list-disc ml-8 mt-1">
                <li>Remote Config does not collect personal content such as your photos, files, or browsing activity</li>
                <li>It does not enable us to access or modify anything on your device remotely. It only controls settings within our app</li>
                <li>Configuration data fetched from Firebase is stored locally on your device</li>
              </ul>
              <p className="ml-2 mt-2">For more information, visit: <a href="https://firebase.google.com/support/privacy" className="text-blue-400">https://firebase.google.com/support/privacy</a></p>

              <h5 className="ml-2 mt-4 font-semibold">Firebase Cloud Messaging</h5>
              <p className="ml-2 mt-2">We use Firebase Cloud Messaging to send push notifications to your device. These notifications may include app updates, feature announcements, reminders, or promotional messages related to our app.</p>
              <p className="ml-2 mt-2 font-semibold">Data collected includes:</p>
              <ul className="list-disc ml-8 mt-1">
                <li>FCM Registration Token (a unique token assigned to your app installation, used to route notifications to your device)</li>
                <li>Device platform and app version (to ensure notification compatibility)</li>
              </ul>
              <p className="ml-2 mt-2 font-semibold">Important disclosures:</p>
              <ul className="list-disc ml-8 mt-1">
                <li>The FCM token is a technical identifier — it does not contain your name, email, or any personal identity information</li>
                <li>We do not use FCM to collect data about your notification interactions beyond what is necessary to deliver the notification</li>
                <li>You can disable push notifications at any time through your device settings.</li>
                <li>On Android 13 and above, we request your explicit permission before sending any notifications</li>
              </ul>
              <p className="ml-2 mt-2">For more information, visit: <a href="https://firebase.google.com/support/privacy" className="text-blue-400">https://firebase.google.com/support/privacy</a></p>

              <h5 className="ml-2 mt-4 font-semibold">Firebase Performance Monitoring</h5>
              <p className="ml-2 mt-2">We use Firebase Performance Monitoring to measure and improve the technical performance of our app. This SDK automatically collects data such as app startup time, screen rendering performance, network request response times, and crash traces.</p>
              <p className="ml-2 mt-2 font-semibold">Data collected includes:</p>
              <ul className="list-disc ml-8 mt-1">
                <li>App version and device information (model, OS version)</li>
                <li>Network request URLs, response codes, and payload sizes</li>
                <li>Screen rendering frame rates</li>
                <li>App start-up duration</li>
              </ul>
              <p className="ml-2 mt-2">This data is used solely to diagnose and fix performance issues. It does not include personal content such as photos, videos, or user-generated files.</p>
              <p className="ml-2 mt-2">For more information, visit: <a href="https://firebase.google.com/support/privacy" className="text-blue-400">https://firebase.google.com/support/privacy</a></p>

              <h5 className="ml-2 mt-4 font-semibold">Firebase In-App Messaging</h5>
              <p className="ml-2 mt-2">We use Firebase In-App Messaging to display contextual messages, tips, or promotional content to users who are actively using the app. These messages may include feature announcements, tips, or promotional offers.</p>
              <p className="ml-2 mt-2 font-semibold">Data collected includes:</p>
              <ul className="list-disc ml-8 mt-1">
                <li>Firebase Installation ID (to identify the app instance)</li>
                <li>App engagement data (to determine when and to whom messages are shown)</li>
              </ul>
              <p className="ml-2 mt-2">No personal content from your device is accessed. Messages are triggered based on in-app behavior (e.g., opening a feature) and not based on personal identity.</p>
              <p className="ml-2 mt-2">For more information, visit: <a href="https://firebase.google.com/support/privacy" className="text-blue-400">https://firebase.google.com/support/privacy</a></p>

              <h5 className="ml-2 mt-4 font-semibold">Firebase Realtime Database</h5>
              <p className="ml-2 mt-2">We use Firebase Realtime Database to store and sync app data in real time. This may include app configuration data, user preferences, or feature-related data necessary for the app to function correctly.</p>
              <p className="ml-2 mt-2">Data stored in the database is protected by Firebase&apos;s security rules and is only accessible to authorized app functions. We do not store sensitive personal information such as payment details, precise location, or biometric data in this database.</p>
              <p className="ml-2 mt-2">For more information, visit: <a href="https://firebase.google.com/support/privacy" className="text-blue-400">https://firebase.google.com/support/privacy</a></p>

              <h5 className="ml-2 mt-4 font-semibold">Firebase AI / Gemini API</h5>
              <p className="ml-2 mt-2">We use Firebase AI (powered by Google&apos;s Gemini models) to enable AI-powered features within the app, such as image editing, content generation, or intelligent suggestions.</p>
              <p className="ml-2 mt-2 font-semibold">When you use an AI-powered feature:</p>
              <ul className="list-disc ml-8 mt-1">
                <li>Your input (such as a selected image or text prompt) may be temporarily processed by Google&apos;s AI infrastructure to generate a result</li>
                <li>Inputs are not used to train Google&apos;s AI models without your consent</li>
                <li>Processed data is not retained by Google beyond the immediate session unless explicitly stated</li>
              </ul>
              <p className="ml-2 mt-2">For more information on how Google handles AI data, visit: <a href="https://firebase.google.com/support/privacy" className="text-blue-400">https://firebase.google.com/support/privacy</a> and <a href="https://ai.google.dev/gemini-api/terms" className="text-blue-400">https://ai.google.dev/gemini-api/terms</a></p>
            </li>
            <li className="mt-4">
              <h4> <strong>GameAnalytics</strong>
                {" "}(by GameAnalytics)
              </h4>

              <p className="mt-2 ml-2">
                We use GameAnalytics for in-game data analytics to improve our
                games.
              </p>
              <p className="mt-2 ml-2">
                For more information about GameAnalytics, please visit their
                Privacy Policy:{" "}
                <a
                  href="https://www.gameanalytics.com/trust/privacy-notice"
                  className="text-blue-400"
                >
                  https://www.gameanalytics.com/trust/privacy-notice
                </a>
              </p>
            </li>
            <li className="mt-4">
              <h4> <strong>Tenjin.io</strong> {" "}(by Tenjin, Inc.)</h4>

              <p className="mt-2 ml-2">
                We use Tenjin for performance attribution.
              </p>
              <p className="mt-2 ml-2">
                For more information on what type of information Tenjin collects, please visit:
                <a
                  href="https://tenjin.com/privacy/"
                  className="text-blue-400"
                >
                  https://tenjin.com/privacy/
                </a>
              </p>
            </li>
            <li className="mt-4">
              <h4><strong>Adjust </strong> {" "} (by Adjust GmbH.)</h4>

              <p className="mt-2 ml-2">
                We use Adjust for performance attribution.
              </p>
              <p className="mt-2 ml-2">
                For more information on what type of information Adjust collects, please visit:{" "}
                <a
                  href="https://www.adjust.com/terms/privacy-policy/"
                  className="text-blue-400"
                >
                  https://www.adjust.com/terms/privacy-policy/
                </a>
              </p>
            </li>
            <li className="mt-4">
              <h4><strong>AppsFlyer</strong>{" "} (by AppsFlyer)</h4>
              <p className="mt-2 ml-2">
                We use AppFlyer for performance attribution.
              </p>
              <p className="mt-2 ml-2" id="Advertising">
                For more information on what type of information AppsFlyer collects, please visit:
                <a
                  href="https://www.appsflyer.com/legal/privacy-policy/"
                  className="text-blue-400"
                >
                  https://www.appsflyer.com/legal/privacy-policy/
                </a>
              </p>
            </li>
          </ul>
          <h3 className="text-black mt-8 text-4xl font-semibold">
            Advertising
          </h3>
          <p>
            We may use third-party Service Providers to display advertisements to you, helping to support and maintain our Service. Advertising is limited to non-personal data.
          </p>
          <p>Our app uses Android's Privacy Sandbox APIs, including the Topics API, Custom Audiences API, and Attribution API. These APIs are provided by Google and are used to serve interest-based advertisements and measure ad performance without relying on cross-app identifiers. Data processed through these APIs is handled in accordance with Google's Privacy Sandbox policies. You can opt out through your device's Ad Privacy settings under Settings → Google → Ads.</p>
          <ul>
            <li className="mt-4">
              <h4><strong>Google User Messaging Platform / Funding Choices</strong> (by Google LLC)</h4>
              <p className="mt-2 ml-2">Our app uses Google&apos;s User Messaging Platform (UMP) SDK to manage advertising consent in compliance with applicable privacy regulations including GDPR, CCPA, and India&apos;s DPDP Act.</p>
              <p className="mt-2 ml-2">When you first open the app (or when regulations require), UMP displays a consent dialog asking whether you agree to personalized advertising. Your response is recorded and transmitted to Google&apos;s Funding Choices service, which then communicates your consent signal to our advertising partners.</p>
              <p className="mt-2 ml-2 font-semibold">What this SDK does:</p>
              <ul className="list-disc ml-6 mt-1">
                <li>Displays consent dialogs required by GDPR (for EU/UK users), CCPA (for California users), and other applicable laws</li>
                <li>Stores your consent preference on your device</li>
                <li>Transmits your consent signal to Google and our ad network partners so they can serve ads in accordance with your choice</li>
                <li>Determines which ad experience you receive — personalized or non-personalized — based on your response</li>
              </ul>
              <p className="mt-2 ml-2 font-semibold">Data involved:</p>
              <ul className="list-disc ml-6 mt-1">
                <li>Your consent choice (yes/no to personalized ads)</li>
                <li>Your approximate region/jurisdiction (to determine which consent rules apply)</li>
                <li>A timestamp of when consent was given or denied</li>
                <li>No sensitive personal data is collected by this SDK. It acts solely as a consent management mechanism.</li>
              </ul>
              <p className="mt-2 ml-2">For more information, visit Google&apos;s Privacy Policy: <a href="https://policies.google.com/privacy" className="text-blue-400">https://policies.google.com/privacy</a></p>
              <p className="mt-2 ml-2">For Funding Choices documentation: <a href="https://support.google.com/fundingchoices/" className="text-blue-400">https://support.google.com/fundingchoices/</a></p>
            </li>
            <li className="mt-4">
              <h4><strong>IronSource </strong>{" "}  (by IronSource Mobile Ltd.)</h4>
              <p className="mt-1 ml-2">
                You can opt out of the IronSource network by following the instructions as described by Ironsource on their Privacy Policy page. Check the link for more information- {" "}
                <a
                  href="https://developers.is.com/ironsource-mobile/air/ironsource-mobile-privacy-policy/"
                  className="text-blue-400"
                >
                  https://developers.is.com/ironsource-mobile/air/ironsource-mobile-privacy-policy/
                </a>
              </p>
            </li>
            <li className="mt-4">
              <h4><strong>MoPub</strong> (Parent company- <strong>AppLovin</strong>)</h4>
              You can opt out of the MoPub service by following the instructions on the MoPub Opt-out page: <a href="https://dash.applovin.com/p/how-applovin-shows-you-ads" className="text-blue-600">https://dash.applovin.com/p/how-applovin-shows-you-ads</a><br />
              For more information on what information MoPub collects and how it is used, please read MoPub Privacy Policy: <a href="https://www.applovin.com/privacy/" className="text-blue-600">https://www.applovin.com/privacy/</a>
            </li>
            <li className="mt-4">
              <h4><strong>Facebook Audience Network</strong> (by Facebook Inc.)</h4>
              For more information about Facebook Audience Network, please visit their Policy: <a href="https://developers.facebook.com/docs/audience-network/optimization/best-practices/an-policy/" className="text-blue-600">https://developers.facebook.com/docs/audience-network/optimization/best-practices/an-policy/</a>
            </li>
            <li className="mt-4">
              <h4><strong>Facebook Marketing</strong> (part of Meta Business)</h4>
              <p className="mt-2 ml-2">The purpose of this SDK is Analytics, ad attribution, and personalized advertising. It collects the following types of data: device information, advertising ID, app events, and usage data. The data usage is to measure ad performance and deliver relevant ads. You can also check their privacy policy — <a href="https://www.facebook.com/privacy/policy/" className="text-blue-600">https://www.facebook.com/privacy/policy/</a></p>
            </li>
            <li className="mt-4">
              <h4><strong>AdMob</strong> (by Google Inc.)</h4>
              Understand how “the end-user data collected by Google Mobile Ads SDK” from the link below- <br></br>
              <a href="https://developers.google.com/admob/android/privacy/play-data-disclosure" className="text-blue-600">https://developers.google.com/admob/android/privacy/play-data-disclosure</a><br />
              You can opt-out from the AdMob by Google service by following the instructions described by Google: <br></br>
              <a href="https://support.google.com/My-Ad-Center-Help/answer/12155764?hl=en" className="text-blue-600">https://support.google.com/My-Ad-Center-Help/answer/12155764?hl=en</a>
              For more information on how Google uses the collected information, please visit the “How Google uses data when you use our partners’ sites or app” page:
              <a href="https://policies.google.com/technologies/partner-sites" className="text-blue-600">https://policies.google.com/technologies/partner-sites</a>
              or visit the Privacy Policy of Google: <a href="https://policies.google.com/privacy" className="text-blue-600">https://policies.google.com/privacy</a>
            </li>
            <li className="mt-4">
              <h4><strong>AppLovin</strong> (by AppLovin Corporation)</h4>
              If you’d like to opt out of AppLovin service, please visit the AppLovin Opt-out page: <a href="https://dash.applovin.com/p/how-applovin-shows-you-ads" className="text-blue-600">https://dash.applovin.com/p/how-applovin-shows-you-ads</a><br />
              If you’d like to learn more about AppLovin, please visit the Privacy Policy page of AppLovin: <a href="https://www.applovin.com/privacy/" className="text-blue-600">https://www.applovin.com/privacy/</a>
            </li>
            <li className="mt-4">
              <h4> <strong>HyprMx</strong> (by HyprMX Mobile LLC.)</h4>
              For more information about HyprMX, please visit their Privacy Policy: <a href="https://jungroup.com/privacy-policy" className="text-blue-600">https://jungroup.com/privacy-policy</a>
            </li>
            <li className="mt-4">
              <h4> <strong>Pangle</strong> (by Bytedance Pte.Ltd.)</h4>
              For more information about Pangle, please visit their Privacy Policy: <a href="https://ad.oceanengine.com/union/media/privacy" className="text-blue-600">https://ad.oceanengine.com/union/media/privacy</a>
            </li>
            <li className="mt-4">
              <h4><strong>Taboola</strong> (by Taboola, Inc.)</h4>
              <p className="mt-2 ml-2">We use it to display sponsored content recommendations and native ads within the app, helping us generate revenue to support free features.</p>
              <p className="mt-2 ml-2">Taboola processes digital identifiers such as cookie IDs, IP addresses, mobile advertising IDs on your device, Taboola network browsing history and associated preferences, and, in some limited circumstances, your hashed email address. IP addresses are truncated upon collection and can only identify the device&apos;s general location, never a precise geolocation.</p>
              <p className="mt-2 ml-2">For more details, check — <a href="https://policies.taboola.com/privacy-policy/" className="text-blue-600">https://policies.taboola.com/privacy-policy/</a><br />Cookie Policy — <a href="https://policies.taboola.com/cookie-policy" className="text-blue-600">https://policies.taboola.com/cookie-policy</a><br />US State Consumer Rights — <a href="https://ccparequest.taboola.com/" className="text-blue-600">https://ccparequest.taboola.com/</a><br />To opt-out, check — <a href="https://accessrequest.taboola.com/access" className="text-blue-600">https://accessrequest.taboola.com/access</a></p>
            </li>
            <li className="mt-4">
              <h4><strong>Outbrain</strong> (by Teads Holding Co.)</h4>
              <p className="mt-2 ml-2">Outbrain is a content recommendation and native advertising network. We use it to display sponsored content recommendations in the app to generate revenue that supports our free features.</p>
              <p className="mt-2 ml-2">Data collected includes unique user identifier (UUID), IP address (truncated to mask identifying information), mobile advertising IDs (such as IDFA or AAID), and content interaction data to serve recommendations based on inferred user interests. It does not conduct cross-device tracking and cannot link a user interacting on their phone to the same user on another device.</p>
              <p className="mt-2 ml-2">For more details, please check — <a href="https://www.outbrain.com/privacy/user-policy/" className="text-blue-600">https://www.outbrain.com/privacy/user-policy/</a></p>
            </li>
            <li className="mt-4">
              <h4><strong>Teads</strong> (by Teads Inc.)</h4>
              <p className="mt-2 ml-2">Teads is an outstream video and display advertising platform. We use it to serve video ad formats within the app, enabling monetization through high-quality video placements.</p>
              <p className="mt-2 ml-2">The data it collects includes device IDs, IP addresses, browsing history (content viewed), product interactions (such as app launches, taps, and clicks), and advertising data, such as information about ads the user has seen. Teads does not knowingly collect or process special categories of sensitive data.</p>
              <p className="mt-2 ml-2">To opt out of its advertising services or for more details, please check — <a href="https://privacy-policy.teads.com/" className="text-blue-600">https://privacy-policy.teads.com/</a><br />For GDPR or CCPA requests, contact <a href="mailto:dpo@teads.com" className="text-blue-600"> dpo@teads.com</a> .</p>
            </li>
            <li className="mt-4">
              <h4><strong>Zemanta</strong> (Outbrain DSP)</h4>
              <p className="mt-2 ml-2">We use it to enable programmatic ad buying that automatically matches the most relevant ads to users in real time.</p>
              <p className="mt-2 ml-2">The data it collects are as follows — Advertising IDs (like IDFA), which are unique IDs associated with individual mobile devices, are used to build a user profile. Users can reset these IDs by instructing their device to do so. It also collects IP addresses, device identifiers, and browsing/interaction signals for ad targeting purposes.</p>
              <p className="mt-2 ml-2">You can get more information about it through its Privacy Policy. If you want to opt-out of its advertising services, feel free to check: <a href="https://www.zemanta.com/opt-out/" className="text-blue-600">https://www.zemanta.com/opt-out/</a><br />And, to check their advertising guidelines, check: <a href="https://www.zemanta.com/advertising-guidelines/" className="text-blue-600">https://www.zemanta.com/advertising-guidelines/</a></p>
            </li>
            <li className="mt-4">
              <h4><strong>Xandr / AppNexus</strong> (by Microsoft)</h4>
              <p className="mt-2 ml-2">We use it to access a broad marketplace of advertisers through real-time bidding, helping us maximize ad revenue while maintaining app quality.</p>
              <p className="mt-2 ml-2">Xandr enables advertising purposes through the use of non-personally identifiable information, which includes browser type, cookie ID, IP address, device identifiers, web pages or apps visited or used, and date and time that web pages or apps were visited. Xandr&apos;s mobile SDKs include client support for the Global Privacy Platform (GPP), GDPR, CCPA, and the Digital Services Act (DSA).</p>
              <p className="mt-2 ml-2">For more details, you can check — <a href="https://help.ads.microsoft.com/#apex/ads/en/ext60205" className="text-blue-600">https://help.ads.microsoft.com/#apex/ads/en/ext60205</a></p>
              <p className="mt-2 ml-2">To opt out of personalized advertising from Xandr (Microsoft), visit Microsoft&apos;s Privacy Statement at <a href="https://privacy.microsoft.com/en-us/privacystatement" className="text-blue-600">https://privacy.microsoft.com/en-us/privacystatement</a> and navigate to the ad settings section. You can also opt out through your mobile device&apos;s advertising settings by limiting ad tracking on Android.</p>
            </li>
            <li className="mt-4">
              <h4><strong>Index Exchange / Casale Media</strong> (by Index Exchange Inc.)</h4>
              <p className="mt-2 ml-2">Index Exchange (formerly Casale Media) is a supply-side advertising exchange. We use it to make our app&apos;s ad inventory available to a wider pool of buyers through programmatic auctions, increasing competition for ad slots and maximizing revenue.</p>
              <p className="mt-2 ml-2">It collects cookies for the purpose of tracking when a user has seen an advertisement. These cookies do not provide personally identifiable information. They are used to inform the exchange whether an advertisement has been served to the same device before, and to facilitate retargeting at a campaign level. Unique user identification numbers are deleted after 90 days of user inactivity and are not tied to any personally identifiable information.</p>
              <p className="mt-2 ml-2">For more details, you can check — <a href="https://www.indexexchange.com/privacy/exchange-platform-privacy-policy/" className="text-blue-600">https://www.indexexchange.com/privacy/exchange-platform-privacy-policy/</a><br />And, you can opt out of targeted advertising through the NAI opt-out tool at <a href="https://optout.networkadvertising.org/" className="text-blue-600">https://optout.networkadvertising.org/</a> or by adjusting your mobile device&apos;s advertising ID settings.</p>
            </li>
            <li className="mt-4">
              <h4><strong>CHEQ / CheqZone</strong> (by CHEQ AI Technologies)</h4>
              <p className="mt-2 ml-2">We use it to protect our advertising ecosystem from invalid traffic, bot activity, and click fraud, to ensure our ad partners receive genuine impressions and to protect our app&apos;s revenue integrity.</p>
              <p className="mt-2 ml-2">CHEQ uses the IP address to determine whether a session is fraudulent. This information is considered personal data under GDPR. CHEQ processes personal data only as necessary to provide its fraud detection services, and data collected is used only for this purpose. CHEQ does not use cookies to track users across websites or for any advertising or targeting purposes. Its cookies are top-level domain cookies used solely to block fraudulent traffic.</p>
              <p className="mt-2 ml-2">For more details, please check — <a href="https://cheq.ai/data-privacy/" className="text-blue-600">https://cheq.ai/data-privacy/</a><br />Users can contact CHEQ directly at <a href="mailto:privacy@cheq" className="text-blue-600">privacy@cheq.ai</a>  for data subject requests or if they want to opt out of its services.</p>
            </li>
            <li className="mt-4">
              <h4><strong>Fyber</strong> (now Digital Turbine)</h4>
              For more information about Fyber, please visit their Privacy Policy: <a href="https://www.digitalturbine.com/legal/privacy-policy" className="text-blue-600">https://www.digitalturbine.com/legal/privacy-policy</a>
            </li>
            <li className="mt-4">
              <h4><strong>Vungle</strong> (by Vungle Inc.)</h4>
              You can opt out of Vungle service by following the instructions as described by Vungle on their Privacy Policy page: <a href="https://vungle.com/privacy/" className="text-blue-600">https://vungle.com/privacy/</a><br />
              For more information about Vungle, please visit their Privacy Policy: <a href="https://vungle.com/privacy/" className="text-blue-600">https://vungle.com/privacy/</a>
            </li>
            <li className="mt-4">
              <h4><strong>Mintegral</strong> (by Mintegral International Ltd.)</h4>
              For more information about Mintegral, please visit their Privacy Policy: <a href="https://www.mintegral.com/en/privacy/" className="text-blue-600">https://www.mintegral.com/en/privacy/</a>
            </li>
            <li className="mt-4">
              <h4> <strong>Unity Ads</strong> (by Unity)</h4>
              For more information about Unity Ads, please visit their Privacy Policy: <a href="https://unity.com/legal/privacy-policy" className="text-blue-600">https://unity.com/legal/privacy-policy</a>
            </li>
            <li className="mt-4">
              <h4><strong>Ogury</strong> (by Ogury Limited)</h4>
              Visit their Privacy Policy: <a href="https://ogury.com/ogury-advertising-privacy-policy/" className="text-blue-600">https://ogury.com/ogury-advertising-privacy-policy/</a>
            </li>
            <li className="mt-4">
              <h4>  <strong>Tapjoy</strong> (by Tapjoy Inc.)</h4>
              You can opt-out of Tapjoy service by following the instructions as described by Tapjoy on their Privacy Policy page: <a href="https://dev.tapjoy.com/en/legal/Advertiser-Terms-Of-Service" className="text-blue-600">https://dev.tapjoy.com/en/legal/Advertiser-Terms-Of-Service</a><br />
              For more information about Tapjoy, please visit their Privacy Policy: <a href="https://dev.tapjoy.com/en/legal/Privacy-Policy" className="text-blue-600">https://dev.tapjoy.com/en/legal/Privacy-Policy</a>
            </li>
            <li className="mt-4">
              <h4><strong>Chartboost</strong> (by Chartboost Inc.)</h4>
              For more information about Chartboost, please visit their Privacy Policy: <a href="https://docs.chartboost.com/en/legal/privacy-policy/" className="text-blue-600">https://docs.chartboost.com/en/legal/privacy-policy/</a>
            </li>
            <li className="mt-4">
              <h4><strong>AdColony</strong> (by Jirbo Inc.)</h4>
              You can opt out of AdColony service, check the link below for more information: <a href="https://www.digitalturbine.com/legal/do-not-sell-or-share-my-personal-information-website" className="text-blue-600">https://www.digitalturbine.com/legal/do-not-sell-or-share-my-personal-information-website</a>
              You can also opt out of AdColony through the Digital Advertising Alliance in the USA <a href="https://optout.aboutads.info/?c=2&lang=EN" className="text-blue-600">https://optout.aboutads.info/?c=2&lang=EN</a> or opt out using your mobile device settings.<br />
              For more information about AdColony, please visit their Privacy Policy: <a href="https://www.digitalturbine.com/legal/do-not-sell-or-share-my-personal-information-website" className="text-blue-600">https://www.digitalturbine.com/legal/do-not-sell-or-share-my-personal-information-website</a>
            </li>
            <li className="my-4">
              <h4><strong>InMobi</strong> (by InMobi Pvt. Ltd.)</h4>
              You can opt out of the InMobi service by following the instructions as described on the InMobi Opt-out page: <a href="https://advertising.inmobi.com/page/opt-out" className="text-blue-600">https://advertising.inmobi.com/page/opt-out</a><br />
              For more information on the privacy practices and policies of InMobi, please visit the InMobi Privacy Policy: <a href="https://advertising.inmobi.com/privacy-policy" className="text-blue-600">https://advertising.inmobi.com/privacy-policy</a>
            </li>
            <li className="my-4">
              <h4><strong>Start.io </strong> (by Start.io Inc.)</h4>
              You can opt out of interest-based ads served by Start.io Inc. (formerly known as StartApp) by following the instructions on their Privacy Policy, section “8. Your Choices and Controls”: <a href="https://www.start.io/policy/privacy-policy/" className="text-blue-600">https://www.start.io/policy/privacy-policy/</a><br />
              For more information on what information Start.io collects and how it is used, please read their Privacy Policy: <a href="https://www.start.io/policy/privacy-policy/" className="text-blue-600">https://www.start.io/policy/privacy-policy/</a>
            </li>
            <li className="my-4">
              <h4><strong>Smaato</strong> (by Smaato, Inc.)</h4>
              For more information on what information Smaato collects and how it is used, please read their Privacy Policy: <a href="https://www.smaato.com/privacy/" className="text-blue-600">https://www.smaato.com/privacy/</a>
            </li>
            <li className="my-4">
              <h4> <strong>Verizon</strong> (by Verizon Communication Inc.)</h4>
              For more information on what information Verizon collects and how it is used, please read their Privacy Policy: <a href="https://www.verizon.com/about/privacy/" className="text-blue-600">https://www.verizon.com/about/privacy/</a>
            </li>
            <li className="my-2" id="BehavioralRemarketing">
              <h4><strong>Google AdSense & DoubleClick Cookie</strong></h4>
              Google, as a third-party vendor, uses cookies to serve ads on our Service. Google's use of the DoubleClick cookie enables it and its partners to serve ads to our users based on their visit to our Service or other websites on the Internet. You may opt out of the use of the DoubleClick Cookie for interest-based advertising by visiting the Google Ads Settings web page: <a href="https://myadcenter.google.com/home?hl=en&sasb=true&ref=ad-settings" className="text-blue-600">https://myadcenter.google.com/home?hl=en&sasb=true&ref=ad-settings</a>
            </li>
          </ul>
          <h3 className="mt-8 text-black text-3xl font-semibold">
            Behavioral Remarketing
          </h3>
          <p className="mt-2 ">
            We use remarketing services to advertise on third-party websites to you after you visit our Service. We and our third-party vendors use cookies to inform, optimise and serve ads based on your past visits to our Service.
          </p>
          <li className="mt-2">
            <strong>Google Ads</strong>
            <p className="mt-2 ml-2">
              Google AdWords remarketing service is provided by Google Inc.{" "}
            </p>
            <p className="mt-2 ml-2">
              You can opt-out of Google Analytics for Display Advertising and
              customise the Google Display Network ads by visiting the Google
              Ads Settings page:{" "}
              <a
                className="text-blue-400"
                href="https://myadcenter.google.com/home?hl=en&sasb=true&ref=ad-settings"
              >
                https://myadcenter.google.com/home?hl=en&sasb=true&ref=ad-settings
              </a>
            </p>
            <p className="mt-2 ml-2">
              Google also recommends installing the Google Analytics Opt-out
              Browser Add-on{" "}
              <a
                className="text-blue-400"
                href="https://tools.google.com/dlpage/gaoptout"
              >
                https://tools.google.com/dlpage/gaoptout
              </a>{" "}
              for your web browser. Google Analytics Opt-out Browser Add-on
              provides visitors with the ability to prevent their data from
              being collected and used by Google Analytics.
            </p>
            <p className="mt-2 ml-2">
              For more information on the privacy practices of Google, please
              visit the Google Privacy & Terms web page:{" "}
              <a
                className="text-blue-400"
                href="https://policies.google.com/privacy?hl=en"
              >
                https://policies.google.com/privacy?hl=en
              </a>
            </p>
          </li>
          <li className="mt-2">
            <strong>Facebook Ads</strong>
            <p className="mt-2 ml-2">
              Facebook remarketing service is provided by Facebook Inc.{" "}
            </p>
            <p className="mt-2 ml-2">
              You can learn more about interest-based advertising from Facebook
              by visiting this page:{" "}
              <a
                className="text-blue-400"
                href="https://www.facebook.com/business/help/488043719226449?id=434838534925385
"
              >
                https://www.facebook.com/business/help/488043719226449?id=434838534925385

              </a>
            </p>
            <p className="mt-2 ml-2">
              To opt-out from Facebook’s interest-based ads, follow these
              instructions from Facebook:{" "}
              <a
                className="text-blue-400"
                href=" https://www.facebook.com/help/568137493302217"
              >
                {" "}
                https://www.facebook.com/help/568137493302217
              </a>
            </p>
            <p className="mt-2 ml-2">
              Facebook adheres to the Self-Regulatory Principles for Online
              Behavioural Advertising established by the Digital Advertising
              Alliance. You can also opt-out from Facebook and other
              participating companies through the Digital Advertising Alliance
              in the USA{" "}
              <a
                href="https://optout.aboutads.info/?c=2&lang=EN"
                className="text-blue-400"
              >
                https://optout.aboutads.info/?c=2&lang=EN
              </a>{" "}
              , the Digital Advertising Alliance of Canada in Canada{" "}
              <a
                className="text-blue-400"
                href="https://optout.aboutads.info/?c=2&lang=EN"
              >
                https://optout.aboutads.info/?c=2&lang=EN
              </a>{" "}
              or the European Interactive Digital Advertising Alliance in Europe{" "}
              <a
                className="text-blue-400"
                href="http://www.youronlinechoices.eu/"
              >
                http://www.youronlinechoices.eu/
              </a>{" "}
              , or opt-out using your mobile device settings.
            </p>
            <p>
              For more information on the privacy practices of Facebook, please
              visit Facebook’s Data Policy:{" "}
              <a
                className="text-blue-400"
                href="https://www.facebook.com/privacy/policy/?entry_point=data_policy_redirect&entry=0"
              >
                https://www.facebook.com/privacy/policy/?entry_point=data_policy_redirect&entry=0
              </a>
            </p>
          </li>
          <li className="mt-2">
            <strong>AppLovin</strong> (by AppLovin Corporation)
            <p>
              If you’d like to opt out of AppLovin service, please visit the AppLovin Opt-out page:
              <a href="https://dash.applovin.com/p/how-applovin-shows-you-ads" className="text-blue-600">https://dash.applovin.com/p/how-applovin-shows-you-ads</a><br />
              If you’d like to learn more about AppLovin, please visit the Privacy Policy page of AppLovin:
              <a href="https://www.applovin.com/privacy/" className="text-blue-600">https://www.applovin.com/privacy/</a></p>
          </li>
          <li className="mt-2">
            <strong>Other Social Media Platforms</strong>
            <p >
              We may use your information to send you marketing and promotional communications about our apps and services. This includes updates, special offers, and news related to our products. You may receive these communications through various channels, including email, push notifications, or in-app messaging.
            </p>
          </li>

          <p className="mt-2">
            To promote our apps and engage with users, we also use a variety of social media platforms such as:
          </p>
          <ul className="pl-5">
            <li className="mt-4">
              <h5> <strong>Facebook - </strong></h5>
              <a href=" https://www.facebook.com/appspacesolutionss
" className="text-blue-600"> https://www.facebook.com/appspacesolutionss
              </a><br />
            </li>
            <li className="mt-4">
              <h5><strong>Instagram - </strong></h5>
              <a href="https://www.instagram.com/appspaceoffical?igsh=c3Zsazh2bmlpMmxx" className="text-blue-600">https://www.instagram.com/appspaceoffical?igsh=c3Zsazh2bmlpMmxx</a><br />
            </li>
            <li className="mt-4">
              <h5> <strong>X (formerly Twitter) - </strong></h5>
              <a href="https://twitter.com/AppSpaceSolu" className="text-blue-600">https://twitter.com/AppSpaceSolu</a>

            </li>
            <li className="mt-4">
              <h5><strong>LinkedIn - </strong></h5>
              <a href=" https://www.linkedin.com/company/appspace-solutions/" className="text-blue-600"> https://www.linkedin.com/company/appspace-solutions/</a>

            </li>
            <li className="mt-4">
              <h5> <strong>YouTube - </strong></h5>
              <a href="https://www.youtube.com/@appspacesolutions" className="text-blue-600">https://www.youtube.com/@appspacesolutions</a><br />

            </li>
            <li className="mt-4">
              <h5><strong>Pinterest - </strong></h5>
              <a href="https://in.pinterest.com/appspacesolutions/" className="text-blue-600">https://in.pinterest.com/appspacesolutions/</a><br />
            </li>

          </ul>
          <p className="mt-4" >
            These platforms allow us to share updates, features, and promotional content, and interact with users who follow our accounts. Please note that while we use these platforms to advertise and promote our apps, we do not share your personal information with these social networks unless you specifically opt-in or interact with our content directly on their platforms.
          </p>
          <p className="mt-4" id="Payments">
            If you do not wish to receive marketing communications, you can opt-out by following the unsubscribe instructions provided in any email or contacting us directly.
          </p>

          <h2 className="mt-8 text-black text-3xl font-semibold">Payments</h2>
          <p className="mt-2 ">
            We may provide paid products and/or services within the Service. In
            that case, we use third-party services for payment processing (e.g.
            payment processors).
          </p>
          <p className="mt-2">
            <strong>
              We will not store or collect your payment card details.
            </strong> That
            information is provided directly to our third-party payment
            processors whose use of your personal information is governed by
            their Privacy Policy. These payment processors adhere to the
            standards set by PCI-DSS as managed by the PCI Security Standards
            Council, which is a joint effort of brands like Visa, MasterCard,
            American Express and Discover. PCI-DSS requirements help ensure the
            secure handling of payment information.
          </p>
          <p className="mt-2">The payment processors we work with are:</p>
          <li className="mt-2 text-lg">
            Apple Store In-App Payments
            <p className="mt-2 text-lg">
              Their Privacy Policy can be viewed at{" "}
              <a
                className="text-blue-400"
                href="https://www.apple.com/legal/privacy/en-ww/"
              >
                https://www.apple.com/legal/privacy/en-ww/
              </a>
            </p>
          </li>
          <li className="mt-2 text-lg">
            Google Play In-App Payments
            <p className="mt-2 text-lg" id="LinkstootherSites">
              Their Privacy Policy can be viewed at{" "}
              <a
                className="text-blue-400"
                href="https://policies.google.com/privacy"
              >
                https://policies.google.com/privacy
              </a>
            </p>
          </li>
          <h2 className="mt-8 text-black text-3xl font-semibold">
            Links to other sites
          </h2>
          <p className="mt-2" id="ChildrensPrivacy">
            Our Service may contain links to other sites that are not operated
            by us. If you click a third party link, you will be directed to that
            third party’s site. We strongly advise you to review the Privacy
            Policy of every site you visit. We have no control over and assume
            no responsibility for the content, privacy policies or practices of
            any third party sites or services.
          </p>
          <h2 className="text-black text-3xl mt-8 font-semibold">
            Children’s Privacy
          </h2>
          <p className="mt-2">
            Our products and services are designed for users who are 13 years of age or older (or the age specified by law in your country/region). If you are a guardian of a child under the age of 13 (or the legal age in your country/region), we encourage you to actively guide and supervise the child during their use of our products, ensuring the safety of their personal information.
          </p>
          <p className="mt-2">
            We advise child users under 13 (or the prescribed age in your country/region) to carefully read this policy with the assistance of a parent or guardian before using our services. All services or the provision of information should only be done with parental or guardian consent. If we discover that we have inadvertently collected personal information from a child, we will take swift action to delete the data.
          </p>
          <h3 className="text-2xl mt-4 text-black font-semibold">Sharing of Children’s Personal Information</h3>
          <p className="mt-2">We are committed to protecting children’s privacy.</p>
          <ul className="list-disc list-inside mt-2">
            <li>We do not sell, rent, or share children’s personal information with third parties for marketing or advertising purposes.</li>
            <li>We do not allow third-party SDKs or ad networks to collect personal data from children for behavioral advertising.</li>
          </ul>
          <p className="mt-2">Any third-party services used in the app are strictly limited to:</p>
          <ul className="list-disc list-inside mt-2">
            <li>Supporting internal operations.</li>
            <li>Ensuring app functionality (such as analytics, crash reporting, or hosting).</li>
          </ul>
          <p className="mt-2">These third parties are required to comply with COPPA (Children’s Online Privacy Protection Act) and other applicable child data protection laws.</p>

          <h3 className="text-2xl mt-4 text-black font-semibold">Public Display and Sharing of Information by Children</h3>
          <p className="mt-2">Our apps are designed to be safe for children.</p>
          <ul className="list-disc list-inside mt-2">
            <li>We do not allow children to publicly share or publish personal information (such as full name, address, phone number, or email).</li>
            <li>If the app includes features like usernames, leaderboards, or game profiles, these are designed to avoid the collection of personally identifiable information and prevent public exposure of sensitive data.</li>
            <li>We use anonymized or non-identifiable data only.</li>
          </ul>
          <p className="mt-2">We actively take steps to prevent accidental sharing of personal information by children.</p>

          <h3 className="text-2xl mt-4 text-black font-semibold">Parental and Caregiver Rights (Children’s Data Rights)</h3>
          <p className="mt-2">In accordance with COPPA and other global privacy regulations, parents and legal guardians have rights regarding their child’s personal information.</p>
          <p className="mt-2">We clearly inform caregivers that they have the right to review, delete, and control the collection and use of their child’s personal data.</p>
          <p className="mt-2"><strong>1. Right to Review Child’s Data</strong></p>
          <p className="mt-1">Parents or legal guardians have the right to request access to the personal information we may have collected from their child.</p>
          <p className="mt-1">To request review access:</p>
          <ul className="list-disc list-inside mt-1">
            <li>Email us at feedback@appspacesolutions.in.</li>
            <li>Use subject line: "Review Child Data".</li>
            <li>Provide necessary verification details.</li>
          </ul>
          <p className="mt-1">We will respond within a reasonable timeframe after verifying your identity.</p>
          <p className="mt-2"><strong>2. Right to Delete Child’s Data</strong></p>
          <p className="mt-1">Parents have the right to request deletion of their child’s personal information.</p>
          <p className="mt-1">To request deletion:</p>
          <ul className="list-disc list-inside mt-1">
            <li>Email us at feedback@appspacesolutions.in.</li>
            <li>Use subject line: "Delete Child Data".</li>
          </ul>
          <p className="mt-1">Once verified, we will delete the data securely. Retention will only occur if required by law.</p>
          <p className="mt-2"><strong>3. Right to Stop Data Collection or Use</strong></p>
          <p className="mt-1">Parents can request that we stop collecting or using their child’s data at any time.</p>
          <p className="mt-1">To exercise this right:</p>
          <ul className="list-disc list-inside mt-1">
            <li>Email: feedback@appspacesolutions.in.</li>
            <li>Subject: "Stop Data Collection".</li>
          </ul>
          <p className="mt-1">After processing, we will stop collecting personal data, and some features of the app may no longer function properly.</p>
          <p className="mt-2"><strong>4. Right to Withdraw Consent</strong></p>
          <p className="mt-1">If consent was previously given, parents may withdraw it at any time. This will stop further data collection and trigger deletion where applicable.</p>
          <p className="mt-2"><strong>5. Right to Know (Transparency Right)</strong></p>
          <p className="mt-1">Parents have the right to know what data is collected, why it is collected, how it is used, and whether it is shared with third parties.</p>
          <p className="mt-2"><strong>Verification Requirement</strong></p>
          <p className="mt-1">To protect children’s privacy, we may require verification of identity before processing any request.</p>

          <h3 className="text-2xl mt-4 text-black font-semibold">Data Minimization and Retention</h3>
          <p className="mt-2">We follow strict data minimization principles to protect user privacy, especially for children.</p>
          <p className="mt-2">We only collect necessary personal information (like device type, model, operating system version, app version, performance data, crash logs, diagnostic information, Advertising ID, usage and analytics data) and only as needed to provide and improve our app’s core functionality.</p>
          <ul className="list-disc list-inside mt-2">
            <li>We do not collect excessive, unnecessary, or unrelated data.</li>
            <li>We ensure that data collection is limited to specific, explicit, and legitimate purposes.</li>
          </ul>
          <p className="mt-2">For child users:</p>
          <ul className="list-disc list-inside mt-2">
            <li>We do not require children to provide personal information to access basic features of the app.</li>
            <li>We avoid collecting personally identifiable information unless absolutely required for functionality.</li>
            <li>Where possible, we use anonymous, aggregated, or non-identifiable data.</li>
          </ul>

          <h3 className="text-2xl mt-4 text-black font-semibold">Default Privacy Settings (Privacy by Design)</h3>
          <p className="mt-2">Our app is designed with privacy by default, especially for children. Features are configured to limit data collection automatically without requiring user action. Any optional data collection is clearly disclosed and requires user or parental awareness where applicable.</p>

          <h3 className="text-2xl mt-4 text-black font-semibold">Data Retention Limitation</h3>
          <p className="mt-2">We retain personal data only for as long as necessary to fulfill the purposes outlined in this policy. We delete or anonymize data securely when it is no longer required. For children’s data, we apply shorter retention periods and stricter safeguards.</p>

          <h3 className="text-2xl mt-4 text-black font-semibold">No Sensitive Data Collection</h3>
          <p className="mt-2">We do not knowingly collect sensitive personal information such as precise location data, contact details (phone number, email) from children, biometric data, or financial information.</p>

          <h3 className="text-2xl mt-4 text-black font-semibold">Limited Access and Internal Controls</h3>
          <p className="mt-2">Access to data is restricted to authorized personnel only. We implement technical and organizational safeguards to prevent unauthorized access, misuse, or disclosure.</p>

          <h3 className="text-2xl mt-4 text-black font-semibold">No Profiling or Behavioral Tracking for Children</h3>
          <p className="mt-2" id="PrivacyPolicyChanges">We do not profile children or track their behavior for advertising or marketing purposes. We do not create user profiles based on children’s activity.</p>
          <h2 className="text-black text-3xl mt-8 font-semibold">
            Changes to this privacy policy
          </h2>
          <p className="mt-2">
            We may update our Privacy Policy from time to time. We will notify
            you of any changes by posting the new Privacy Policy on this page.
            We will let you know via email and/or a prominent notice on our
            Service, prior to the change becoming effective and update the
            “effective date” at the top of this Privacy Policy.
          </p>
          <p className="mt-2 " >
            You are advised to review this Privacy Policy periodically for any
            changes. Changes to this Privacy Policy are effective when they are
            posted on this page.
          </p>
          <h2 className="mt-8 text-black text-3xl font-semibold" id="ContactUs">Contact us</h2>
          <p className="mt-2 mb-20">
            If you have any questions or suggestions, please contact us at  <a href="mailto:feedback@appspacesolutions.in" className="text-blue-700 underline">feedback@appspacesolutions.in</a>.
            We are also open to your feedback.
          </p>
        </div>
      </main>
    </>
  );
};

export default Privacy;
